import { toFixed } from 'accounting'
import axios from 'axios'
import IMask from 'imask'
import { DateTime } from 'luxon'
import React, {
  lazy,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'
import { IconType } from 'react-icons'
import { BiMinus } from 'react-icons/bi'
import { FaArrowLeft } from 'react-icons/fa'
import { FiAlertTriangle } from 'react-icons/fi'
import { HiCheck, HiOutlinePencil } from 'react-icons/hi'
import { IoMdAdd } from 'react-icons/io'
import { RiDeleteBin6Line } from 'react-icons/ri'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import {
  ColumnsTable,
  HeaderActions,
  IClient,
  IExistenceInSale,
  IItem,
  IMoneyAccount,
  IWarehouse,
} from 'safe'
import { v4 as uuidv4 } from 'uuid'
import { ColumnItemWrapper } from '../../components/General/ColumnItemWrapper'
import { TabContext } from '../../context/TabContext'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { fectchAccounts } from '../../redux/actions/accounts'
import { createClient } from '../../redux/actions/clients'
import { fetchRates } from '../../redux/actions/rates'
import { RootState } from '../../redux/store'
import { tax } from '../../userConfig'
import {
  dateToDB,
  formatPipe,
  getDenomination,
  getIvaNumber,
} from '../../utils/utils'

const Modal = lazy(() => import('../../components/Display/Modal'))
const Table = lazy(() => import('../../components/Display/Table'))
const Button = lazy(() => import('../../components/General/Button'))
const ClientForm = lazy(() => import('../Clients/ClientsForm'))
const TransferForm = lazy(() => import('./TransferForm'))
const CardForm = lazy(() => import('./CardForm'))
const CashForm = lazy(() => import('./CashForm'))
const WalletForm = lazy(() => import('./WalletForm'))
const PdfView = lazy(() => import('../../components/Display/PdfView'))
const ControlNumberForm = lazy(() => import('./ControlNumberForm'))
const AdvancedSearch = lazy(
  () => import('../../components/Inputs/AdvancedSearch')
)
const IgtfForm = lazy(() => import('./IgtfForm'))
const Switch = lazy(() => import('../../components/Inputs/Switch'))
const PdfSaleBudget = lazy(() => import('./PdfSaleBudget'))

enum accountTypeEnum {
  CASH = 'CASH',
  BANKACCOUNT = 'BANK ACCOUNT',
  WALLET = 'WALLET',
  CARD = 'CARD',
  mobilePayment = 'mobilePayment',
  nationalTransfer = 'nationalTransfer',
  CREDIT = 'CREDIT',
  IGTF = 'IGTF',
}

enum TypeStatus {
  DONE = 'DONE',
  UNDONE = 'UNDONE',
}

const server = process.env.REACT_APP_SERVER_URL

const Budgets: React.FC<SellProps> = ({
  setHeaderActions,
  clientProp = null,
  itemsProp = [],
  statusProp = 'REFUND',
  selldId,
  payment_methods = [],
  onGoBack,
  type = '',
  alreadySelledProp = false,
  paidOut = false,
  dispatchStatusProps = 'UNDISPATCHED',
  onContinue = () => {},
}) => {
  const history = useHistory()
  const today = DateTime.local().setLocale('es')

  const { value, onClick } = useContext(TabContext)

  const [isDisableForDay, setIsDisableForDay] = useState<boolean>(false)

  const refDocument = useRef<HTMLInputElement | null>(null)

  const refCode = useRef<HTMLInputElement | null>(null)

  const refQuantity = useRef<HTMLInputElement | null>(null)

  const refInputAdvanced = useRef<HTMLInputElement | null>(null)

  const [selectedClient, setSelectedClient] =
    useState<any | null | undefined>(clientProp)

  const [selectedItems, setSelectedItems] =
    useState<
      | (IItem & {
          amount: string
          enableEdit: boolean
          id_item_sale: string
          updated?: boolean
          ivaType: 'GENERAL' | 'REDUCED' | 'EXEMPT' | 'SUMPTUARY'
          currency: { id: string }
        })[]
      | undefined
    >(itemsProp)

  const [searchClient, setSearchClient] = useState<IClient[]>([])

  const [searchItems, setSearchItems] = useState<IExistenceInSale[]>([])

  const [error, setError] = useState<string | null>(null)

  const [showModalItems, setShowModalItems] = useState<boolean>(false)

  const [itemToSearch, setItemToSearch] = useState<string>('')

  const [itemsSearched, setItemsSearched] = useState<IExistencesResponse[]>([])

  const [showAddClient, setShowAddClient] = useState<boolean>(false)

  const [isPaymentMethod, setIsPaymentMethod] = useState<boolean>(false)

  const [showMethod, setShowMethod] = useState<boolean>(false)

  const [selectedMethod, setSelectedMethod] = useState<IMethods | null>(null)

  const [isFreeForm, setIsFreeForm] = useState<boolean>(true)

  const [showPdf, setShowPdf] = useState<boolean>(false)

  const [showPdfDeliveryNote, setShowPdfDeliveryNote] = useState<boolean>(false)

  const [selectedMethods, setSelectedMethods] = useState<any>(payment_methods)

  // const [accountsFilter, setAccounts] = useState(
  //   useSelector((state: RootState) => state.acct.accounts)
  // )

  const [correlativeNumber, setCorrelativeNumber] = useState<string>('')

  const [alreadySelled, setAlreadySelled] = useState<boolean>(alreadySelledProp)

  const [isPayed, setIsPayed] = useState<boolean>(false)

  const [dispatchStatus, setDispatchStatus] =
    useState<string>(dispatchStatusProps)

  const dispatch = useDispatch()

  const clients = useSelector((state: RootState) => state.clie.clients)

  const userName = useSelector((state: RootState) => state?.auth?.user?.name)

  const userRole = useSelector(
    (state: RootState) => state?.auth?.user['custom:user_role']
  )

  const globalRateRedux = useSelector((state: RootState) => state?.rates.rates)

  let alreadyInitialized = useRef<boolean>(false)

  const { addAlert } = useSnackBars()

  const [finishedDeliveryToSale, setFinishedDeliveryToSale] =
    useState<boolean>(false)

  const [stateBills, setStateBills] = useState<Bill[]>([])

  const [status, setStatus] = useState<any>(statusProp)

  const [showModalControlNumber, setShowModalControlNumber] =
    useState<boolean>(false)

  const accounts = useSelector((state: RootState) => state.acct.accounts)

  const warehouses = useSelector((state: RootState) => state.warh.warehouses)

  const [globalRate, setGlobalRate] = useState<IGlobalRate[]>([])

  const [igtfAmount, setIgtfAmount] = useState<number>(0)

  const [isCashOut, setIsCashOut] = useState<boolean>(true)

  const [credit, setCredit] = useState<ICredit | null>(null)

  const [disableDiscount, setDisableDiscount] = useState<boolean>(false)

  const [discountValue, setDiscountValue] = useState<number>(0)

  const [showAdvancedPayable, setShowAdvancedPayable] = useState<boolean>(false)

  const [invoiceNumber, setInvoiceNumber] = useState<string>('')

  const discountRef = useRef<any>(null)

  const [saleDate, setSaleDate] = useState<string>(
    DateTime.local().setLocale('es').toFormat('d/M/yyyy')
  )

  const [modalRate, setModalRate] = useState<string | null>(null)

  const [isFirstRender, setIsFirstRender] = useState<boolean>(true)

  const [userInfo, setUserInfo] = useState<any | null>(null)

  const [showCurrencyModal, setShowCurrencyModal] = useState<boolean>(false)

  const [selectedPdfCurrency, setSelectedPdfCurrency] = useState<'1' | '2'>('2')

  const [pdfData, setPdfData] = useState<any>(null)

  // const refDisable = useRef<HTMLInputElement|null>(null)

  // const styles = StyleSheet.create({
  //   general: {
  //     padding: 40,
  //   },
  //   page: {
  //     flexDirection: 'row',
  //     justifyContent: 'space-between',
  //     width: '40%',
  //     marginBottom: '2%',
  //   },
  //   section: {
  //     flexGrow: 1,
  //   },
  //   items: {
  //     display: 'flex',
  //     flexDirection: 'row',
  //     justifyContent: 'space-between',
  //     borderBottom: '1px dashed black',
  //   },
  //   priceTotal: {
  //     display: 'flex',
  //     alignItems: 'flex-end',
  //     marginTop: '2%',
  //   },
  //   priceUnit: {
  //     display: 'flex',
  //     justifyContent: 'flex-end',
  //   },
  //   amounts: {
  //     flexDirection: 'row',
  //     justifyContent: 'space-between',
  //     width: '35%',
  //     marginBottom: '2%',
  //   },
  // })

  useEffect(() => {
    console.log('Selected methods', toFixed(0.615, 2))
    console.log('Selected methods', (0.615).toFixed(2))
  }, [selectedMethods])

  useEffect(() => {
    // history.push('/dashboard/modulo_ventas/ventas')
    console.log('clickeando desde ventas...')
    if (showPdf) {
      console.log('llega..')
      setShowPdf(false)
      setSelectedClient(null)
      setSelectedItems([])
      setSearchClient([])
      setSearchItems([])
      // setSelectedMethod([])
      setSelectedMethods([])
      setIsCashOut(true)
      setIsPaymentMethod(false)
    }
  }, [value])

  const getUserInfo = async (): Promise<void> => {
    let userResponse = await axios.get(`${server}/user/tenant`)
    setUserInfo(userResponse?.data?.tenant)
  }

  useEffect(() => {
    getUserInfo()
  }, [])

  // useEffect(() => {

  // }, [invoiceNumber])

  useEffect(() => {
    let numberMask = IMask(discountRef.current, {
      mask: Number,
      thousandsSeparator: '.',
      radix: ',',
      scale: 2,
      normalizeZeros: true,
      padFractionalZeros: true,
      signed: false,
      max: 10000000000000,
    })

    numberMask.on('accept', () => {
      setDiscountValue(+numberMask.unmaskedValue)
    })
  }, [])

  const [windowSize, setWindowSize] = useState(getWindowSize())

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize())
    }

    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  function getWindowSize() {
    const { innerWidth, innerHeight } = window
    return { innerWidth, innerHeight }
  }

  const getRate = async (
    date = today.toISODate(),
    fromRedux = true
  ): Promise<void> => {
    if (fromRedux) {
      const today = DateTime.local().setLocale('es')
      // let date = today.toISODate()
      dispatch(fetchRates([`date=${date}`, `currency=${'all'}`]))
      // let response = await axios.get<{ rates: IGlobalRate[] }>(
      //   `${server}/finances/rate?date=${date}&currency=all`
      // )
      // console.log('response...', response)
      // setGlobalRate(response.data.rates)
    } else {
      let response = await axios.get(
        `${server}/finances/rate?date=${date}&currency=${'all'}`
      )
      setGlobalRate(response.data.rates)
      if (!isFirstRender) {
        setModalRate(
          response?.data?.rates?.find((rate) => rate?.id === '1')?.rate
        )
      }
      setIsFirstRender(false)
    }
  }

  useEffect(() => {
    getRate()
  }, [])

  useEffect(() => {
    if (globalRateRedux.length) {
      setGlobalRate(globalRateRedux)
    }
  }, [globalRateRedux])

  const onSearchClient = async (
    value = refInputAdvanced?.current?.value,
    isFromNewClient = false
  ): Promise<void> => {
    // if (
    //   /^[^vjepgc].+$/gi.test(
    //     (refDocument.current && refDocument.current.value) || ''
    //   )
    // ) {
    //   setError('Cédula inválida')
    //   return
    // }
    // const documentInfo = refDocument?.current?.value.split('-')
    // let response = await axios.get<{ clients: IClient[] }>(
    //   `${server}/thirdparty/client?document=${
    //     documentInfo && documentInfo[1]
    //   }&documentType=${documentInfo && documentInfo[0]}&pageNumber=1&pageSize=5`
    // )
    // setError('')

    let response = await axios.get(
      `${server}/thirdparty/client?${[
        ...[`fastSearch=${value}`],
        ...[`pageNumber=${1}&pageSize=${10}`],
      ].join('&')}`
    )
    setSearchClient(response.data.clients)

    // setSelectedClient(
    //   response.data.clients.find(
    //     (client) =>
    //       client.document.document === (documentInfo && documentInfo[1]) &&
    //       client.document.documentType === (documentInfo && documentInfo[0])
    //   )
    // )
    // refDocument.current && (refDocument.current.value = '')
    // refCode.current && (refCode.current.value = '')

    if (response.data.clients.length === 0) {
      addAlert({
        message: 'No se encontraron clientes',
        status: 'error',
      })
      return
    }

    if (isFromNewClient) {
      setSelectedClient(response.data.clients[0])
    }
  }

  const onSearchItem = async (
    value = refCode?.current?.value
  ): Promise<void> => {
    if (value === '') {
      addAlert({
        message: 'Debe de al menos escribir un caracter',
        status: 'error',
      })
      return
    }

    setSearchItems([])
    // let response =  await axios.get<{existencesOfWarehouse: IExistence[]}>(`${server}/inventory/existence?evaluate=code&idWarehouse=1&pageNumber=1&pageSize=100&code=${refCode.current?.value}`)
    // console.log("respinse", response.data.existencesOfWarehouse.find(v => v.))
    // let response = await axios.get<{ items: IItem[] }>(
    //   `${server}/inventory/item/search/custom?searchCustom=${refCode.current?.value}`
    // )
    // console.log("response1", response1)
    // console.log(response.data.existencesOfWarehouse.find(existence => existence.item.barcode === (refCode?.current && refCode.current?.value) || existence.item.sku === (refCode?.current && refCode.current?.value)) )
    //@ts-ignore
    // setSelectedItems((prevState) => [...prevState,{amount: refQuantity.current.value,
    //     ...response.data.items.find(
    //       (item) =>
    //         item.barcode === (refCode?.current && refCode.current?.value) ||
    //         item.sku === (refCode?.current && refCode.current?.value)
    //     ),
    //   },
    // ])

    let warehouseId = warehouses[0]?.id

    let [items, services] = await Promise.all([
      await axios.get(
        `${server}/inventory/item/simple-search?param=${value}&pageNumber=${1}&pageSize=${10}`
      ),
      await axios.get(
        `${server}/service?name=${value}&${['pageNumber=1', 'pageSize=10'].join(
          '&'
        )}`
      ),
    ])

    // let [items, services] = await Promise.all([
    //   await axios.get(
    //     `${server}/inventory/existence?id=${warehouseId}&${[
    //       `fastSearch=${value}`,
    //       `sale=true`,
    //       `pageNumber=${1}&pageSize=${10}`,
    //     ].join('&')}`
    //   ),
    //   await axios.get(
    //     `${server}/service?name=${value}&${['pageNumber=1', 'pageSize=10'].join(
    //       '&'
    //     )}`
    //   ),
    // ])

    console.log('items...', items)
    console.log('services...', services)

    // let response = await axios.get(
    //   `${server}/inventory/existence?id=${warehouseId}&${[
    //     `fastSearch=${value}`,
    //     `sale=true`,
    //     `pageNumber=${1}&pageSize=${10}`,
    //   ].join('&')}`
    // )

    if (items?.data?.items?.length > 0) {
      setSearchItems((prevState) => [...prevState, ...items?.data?.items])
    }

    if (services?.data?.services?.length > 0) {
      setSearchItems((prevState) => [...prevState, ...services?.data?.services])
    }

    // setSearchItems([...items?.data?.items, ...services?.data?.services])
    refCode?.current && (refCode.current.value = '')
    refQuantity?.current && (refQuantity.current.value = '')

    // if (items?.data?.items?.length  === 1) {
    //   onPressRow(items.data.items[0])
    // }

    if (
      items?.data?.existence?.length === 0 &&
      services?.data?.services?.length === 0
    ) {
      addAlert({
        message: 'No se encontraron artículos ni servicios',
        status: 'error',
      })
    }
  }

  const returnBody = (surplusAction: 'PAYABLE' | 'ADVANCE') => {
    let warehouse = warehouses[0]?.id
    const today = DateTime.local().setLocale('es')

    return {
      saleClient: {
        id: selectedClient?.id,
      },
      warehouse: {
        id: warehouse,
      },
      paidOut: false,
      description: 'Una venta',
      total: toFixed(getTotalAmount(), 2),
      // total: getTotalAmount().toFixed(2),
      discount: discountValue + '',
      iva: toFixed(sumOfValues('iva'), 2),
      // iva: sumOfValues('iva').toFixed(2),
      igtf: toFixed(igtfAmount, 2),
      // igtf: igtfAmount.toFixed(2),
      date: dateToDB(saleDate),
      currency: {
        id: '2',
      },
      payments: selectedMethods.map((v) => {
        const { type, ...rest } = v
        return rest
      }),
      items: selectedItems,
      surplusAction,
    }
  }

  const onGetRate = (idCurrency: string | undefined): string => {
    // console.log("globalRate...", globalRate)
    return globalRate.find((rate) => rate.id === idCurrency)?.rate || '1'
  }

  const convertItemToTargetCurrency = (
    item: any,
    targetCurrencyId: '1' | '2'
  ): number => {
    const itemPrice = parseFloat(item.price)
    const itemCurrencyId = item.currency.id

    // Si ya está en la moneda objetivo, retornar directo
    if (itemCurrencyId === targetCurrencyId) {
      return itemPrice
    }

    // Obtener tasa de cambio congelada del día actual
    const rate = parseFloat(onGetRate('1')) // Tasa USD/REF

    if (targetCurrencyId === '1') {
      // Convertir Bs → REF (dividir)
      return +toFixed(itemPrice / rate, 2)
    } else {
      // Convertir REF → Bs (multiplicar)
      return +toFixed(itemPrice * rate, 2)
    }
  }

  const prepareDataForPdf = (targetCurrencyId: '1' | '2') => {
    // Convertir cada item a la moneda objetivo
    const convertedItems = selectedItems?.map(item => {
      const convertedPrice = convertItemToTargetCurrency(item, targetCurrencyId)
      const totalPrice = +toFixed(convertedPrice * parseFloat(item.amount), 2)

      return {
        ...item,
        priceInTargetCurrency: convertedPrice,
        totalInTargetCurrency: totalPrice
      }
    })

    // Calcular subtotal en la moneda objetivo
    const subTotalConverted = convertedItems?.reduce(
      (sum, item) => sum + parseFloat(item.totalInTargetCurrency + ''),
      0
    ) || 0

    // Convertir descuento
    const rate = parseFloat(onGetRate('1'))
    const discountConverted = targetCurrencyId === '1'
      ? +toFixed(discountValue / rate, 2)
      : discountValue

    // Calcular IVA sobre el subtotal convertido
    const ivaConverted = +toFixed(
      convertedItems?.reduce((sum, item) => {
        if (item.ivaType === 'EXEMPT') return sum
        const itemTotal = parseFloat(item.totalInTargetCurrency + '')
        const ivaPercent = parseFloat(
          (getIvaNumber(item.ivaType) + '').replace(/\d\./, '')
        ) / 100
        return sum + (itemTotal * ivaPercent)
      }, 0) || 0,
      2
    )

    const totalConverted = +toFixed(
      subTotalConverted + ivaConverted - discountConverted,
      2
    )

    return {
      items: convertedItems,
      subTotal: subTotalConverted,
      discount: discountConverted,
      iva: ivaConverted,
      total: totalConverted,
      currencySymbol: targetCurrencyId === '1' ? 'REF' : 'Bs.',
      currencyLabel: targetCurrencyId === '1' ? 'REF' : 'Bs'
    }
  }

  const handleGeneratePdf = () => {
    const data = prepareDataForPdf(selectedPdfCurrency)
    setPdfData(data)
    setShowCurrencyModal(false)
    setShowPdf(true)
  }

  const handleCancelCurrency = () => {
    setShowCurrencyModal(false)
    setSelectedPdfCurrency('2') // Reset a default
  }

  const sumOfValues = (prop: string): number => {
    return selectedItems?.reduce(
      (a, b) => {
        // a['iva'] += b.exempt
        //   ? 0
        //   : +((+b?.price / getIvaNumber(b?.ivaType) ) * (tax / 100)) *
        //     +b?.amount
        // a['iva'] += b.ivaType === 'EXEMPT' ? +b.price : (+b.price * + ((getIvaNumber(b?.ivaType) + "").replace(/\d\./, ""))/100)
        a['iva'] =
          b.ivaType === 'EXEMPT'
            ? a['iva']
            : // :  (+b.price *
              //     +b.amount *
              //     +onGetRate(b.currency.id) *
              //     +(getIvaNumber(b?.ivaType) + '').replace(/\d\./, '') ) /
              //   100
              +a['iva'] +
              +toFixed(+b.price * +b.amount * +onGetRate(b?.currency?.id), 2) *
                +toFixed(
                  +(getIvaNumber(b?.ivaType) + '').replace(/\d\./, '') / 100,
                  2
                )
        // a['exempt'] += b.exempt ? +b.price * +b.amount : 0
        // a['sub_total'] += !b.exempt
        //   ? +(
        //       (+b?.price / getIvaNumber(b?.ivaType)) *
        //       +b.amount
        //     ).toFixed(2)
        //   : 0
        a['sub_total'] =
          b.currency.id === '2'
            ? +toFixed(a['sub_total'] + +b?.price * +b?.amount, 2)
            : +toFixed(
                a['sub_total'] +
                  +b.price * +b.amount * +onGetRate(b.currency.id),
                2
              )
        a['total'] = +toFixed(+a['total'] + +b.price * +b.amount, 2)
        return a
      },
      { iva: 0, exempt: 0, total: 0, sub_total: 0 }
    )[prop]
  }

  // const getTotalAmount = () =>
  //   +sumOfValues('sub_total').toFixed(2) +
  //   +sumOfValues('iva').toFixed(2) +
  //   +sumOfValues('exempt').toFixed(2) +
  //   +igtfAmount.toFixed(2)

  const getTotalAmount = (withDiscount: boolean = true) =>
    +toFixed(sumOfValues('sub_total'), 2) +
    +toFixed(sumOfValues('iva'), 2) +
    +toFixed(igtfAmount - (withDiscount ? discountValue : 0), 2)

  // const onGetDebt = (): string => {
  //   return (
  //     getTotalAmount() -
  //     +selectedMethods.reduce((a, b) => a + +b.amount * +b?.rate, 0)
  //   ).toFixed(2)
  // }

  const onGetDebt = (): string => {
    return toFixed(
      +toFixed(getTotalAmount(), 2) -
        +toFixed(
          +selectedMethods.reduce((a, b) => a + +b.amount * +b?.rate, 0),
          2
        ),
      2
    )
  }

  const debt = useMemo(
    () => onGetDebt(),
    [selectedMethods, selectedItems, igtfAmount, saleDate, discountValue]
  )

  const onGetChange = (): any => {
    let change = toFixed(
      +selectedMethods.reduce((a, b) => {
        if (b.type === 'Efectivo') {
          return a + +b.amount * +b?.rate
        }
        return a
      }, 0),
      2
    )
    if (+change > +getTotalAmount()) {
      return toFixed(+toFixed(+change, 2) - +toFixed(getTotalAmount(), 2), 2)
    }
    return 0
  }

  useEffect(() => {
    console.log('VER 01', +toFixed(getTotalAmount(false), 2))
    console.log('VER 02', discountValue)
  }, [discountValue, getTotalAmount])

  const formatValueToSave = (method: IMoneyAccount) => {
    console.log('method', method)

    if (method?.type === 'Crédito') {
      console.log('in...')
      return {
        ...method,
        accountType: accountTypeEnum.CREDIT,
      }
    }

    if (method.cardSwiperNumber !== '') {
      return {
        ...method,
        accountType: 'CARD',
      }
    }

    if (method.type === 'Cuenta Bancaria') {
      return {
        ...method,
        accountType: 'WIRE TRANSFER',
      }
    }

    if (method.mobilePaymentPhone !== '') {
      return {
        ...method,
        accountType: 'MOBILE PAYMENT',
      }
    }

    // if (method.bankAccountNumber !== '') {
    //   return {
    //     ...method,
    //     accountType: 'WIRE TRANSFER',
    //   }
    // }

    return method
  }

  const onCreateSell = async (): Promise<void> => {
    if (+debt > 0 && isCashOut) {
      addAlert({
        message: 'El monto de pago debe de ser mayor o igual al monto de venta',
        status: 'error',
      })
      return
    }

    let services = selectedItems?.filter((service) => !service?.category?.id)

    let items = selectedItems?.filter((item) => item?.category?.id)

    let paymentMethodType = {
      'Billetera Virtual': 'WALLET',
      'Cuenta Bancaria': 'TRANSFERENCE',
      Efectivo: 'CASH',
      'Punto de venta': 'CARD',
      'Pago Móvil': 'MOBILE PAYMENT',
      Crédito: 'CREDIT',
    }

    console.log('selected methods', selectedMethods)

    const today = DateTime.local().setLocale('es')

    console.log('selected methods...', selectedMethods)

    /** Ya que en este plan de momento solo se tendrá un almacen  */
    let warehouse = warehouses[0]?.id

    let objBody = {}

    if (
      credit?.finalDate &&
      credit.installmentQuantity &&
      credit.installmentRange &&
      credit.startDate
    ) {
      if (services?.length && items?.length) {
        objBody = {
          saleClient: {
            id: selectedClient?.id,
          },
          warehouse: {
            id: warehouse,
          },
          paidOut: false,
          description: 'Una venta',
          total: toFixed(getTotalAmount(), 2),
          // total: getTotalAmount().toFixed(2),
          discount: discountValue + '',
          iva: toFixed(sumOfValues('iva'), 2),
          // iva: sumOfValues('iva').toFixed(2),
          igtf: toFixed(igtfAmount, 2),
          // igtf: igtfAmount.toFixed(2),
          date: dateToDB(saleDate),
          // date: today.toISODate(),
          currency: {
            id: '2',
          },
          items,
          services,
          credit: {
            ...credit,
            startDate: dateToDB(credit.startDate),
            finalDate: dateToDB(credit.finalDate),
          },
        }
      }

      if (services?.length) {
        objBody = {
          saleClient: {
            id: selectedClient?.id,
          },
          warehouse: {
            id: warehouse,
          },
          paidOut: false,
          description: 'Una venta',
          total: toFixed(getTotalAmount(), 2),
          // total: getTotalAmount().toFixed(2),
          discount: discountValue + '',
          iva: toFixed(sumOfValues('iva'), 2),
          // iva: sumOfValues('iva').toFixed(2),
          igtf: toFixed(igtfAmount, 2),
          // igtf: igtfAmount.toFixed(2),
          date: dateToDB(saleDate),
          currency: {
            id: '2',
          },
          services,
          credit: {
            ...credit,
            startDate: dateToDB(credit.startDate),
            finalDate: dateToDB(credit.finalDate),
          },
        }
      }

      if (items?.length) {
        objBody = {
          saleClient: {
            id: selectedClient?.id,
          },
          warehouse: {
            id: warehouse,
          },
          paidOut: false,
          description: 'Una venta',
          total: toFixed(getTotalAmount(), 2),
          // total: getTotalAmount().toFixed(2),
          discount: discountValue + '',
          iva: toFixed(sumOfValues('iva'), 2),
          // iva: sumOfValues('iva').toFixed(2),
          igtf: toFixed(igtfAmount, 2),
          // igtf: igtfAmount.toFixed(2),
          date: dateToDB(saleDate),
          currency: {
            id: '2',
          },
          items,
          credit: {
            ...credit,
            startDate: dateToDB(credit.startDate),
            finalDate: dateToDB(credit.finalDate),
          },
        }
      }
    } else if (+debt === 0) {
      if (items?.length && services?.length) {
        objBody = {
          saleClient: {
            id: selectedClient?.id,
          },
          warehouse: {
            id: warehouse,
          },
          paidOut: true,
          description: 'Una venta',
          // total: getTotalAmount().toFixed(2),
          total: toFixed(getTotalAmount(), 2),
          discount: discountValue + '',
          // iva: sumOfValues('iva').toFixed(2),
          iva: toFixed(sumOfValues('iva'), 2),
          // igtf: igtfAmount.toFixed(2),
          igtf: toFixed(igtfAmount, 2),
          date: dateToDB(saleDate),
          payments: selectedMethods.map((v) => {
            const { type, ...rest } = v
            return rest
          }),
          currency: {
            id: '2',
          },
          items,
          services,
        }
      }

      if (items?.length) {
        objBody = {
          saleClient: {
            id: selectedClient?.id,
          },
          warehouse: {
            id: warehouse,
          },
          paidOut: true,
          description: 'Una venta',
          // total: getTotalAmount().toFixed(2),
          total: toFixed(getTotalAmount(), 2),
          discount: discountValue + '',
          // iva: sumOfValues('iva').toFixed(2),
          iva: toFixed(sumOfValues('iva'), 2),
          // igtf: igtfAmount.toFixed(2),
          igtf: toFixed(igtfAmount, 2),
          date: dateToDB(saleDate),
          payments: selectedMethods.map((v) => {
            const { type, ...rest } = v
            return rest
          }),
          currency: {
            id: '2',
          },
          items,
        }
      }

      if (services?.length) {
        objBody = {
          saleClient: {
            id: selectedClient?.id,
          },
          warehouse: {
            id: warehouse,
          },
          paidOut: true,
          description: 'Una venta',
          // total: getTotalAmount().toFixed(2),
          total: toFixed(getTotalAmount(), 2),
          discount: discountValue + '',
          // iva: sumOfValues('iva').toFixed(2),
          iva: toFixed(sumOfValues('iva'), 2),
          // igtf: igtfAmount.toFixed(2),
          igtf: toFixed(igtfAmount, 2),
          date: dateToDB(saleDate),
          payments: selectedMethods.map((v) => {
            const { type, ...rest } = v
            return rest
          }),
          currency: {
            id: '2',
          },
          services,
        }
      }
    }

    if (+debt < 0) {
      // addAlert({
      //   message: 'El total ingresado debe de ser mayor o igual a la deuda',
      //   status: 'error',
      // })
      // return
      setShowAdvancedPayable(true)
      return
    }

    try {
      addAlert({ message: 'Creando venta...', status: 'loading' })
      let userResponse = await axios.get(`${server}/user/tenant`)
      let configResponse = await axios.get(`${server}/config/tenant`)
      //Respuesta que se usará para el codigo
      let response = await axios.post(`${server}/sale`, objBody)

      if (selectedClient?.email) {
        let emailBody = {
          invoiceCode: response?.data?.invoice?.code,
          nevulaUser: {
            businessName: userResponse?.data?.tenant?.businessSocial,
          },
          client: {
            name: selectedClient?.name,
            document: `${selectedClient?.documentType}-${selectedClient?.document}`,
            email: selectedClient?.email,
          },
          // subTotal: sumOfValues('sub_total').toFixed(2),
          subTotal: toFixed(sumOfValues('sub_total'), 2),
          // iva: sumOfValues('iva').toFixed(2),
          iva: toFixed(sumOfValues('iva'), 2),
          discount: discountValue + '',
          // igtf: igtfAmount.toFixed(2),
          igtf: toFixed(igtfAmount, 2),
          // total: getTotalAmount().toFixed(2),
          total: toFixed(getTotalAmount(), 2),
          date: dateToDB(saleDate),
          userMessage: configResponse?.data?.userConf?.saleEmailMessage,
          logoURL: userResponse.data.tenant.image,
          // 'https://i.pinimg.com/736x/ec/7c/af/ec7cafae1224c318796d41e728eacb6d.jpg',
          items: selectedItems?.map((item) => ({
            quantity: item.amount,
            description: item.name,
            unitPrice: item.price,
            totalPrice: +item?.amount * +item?.price,
          })),
        }
        let responseEmail = await axios.post(`${server}/sale/email`, emailBody)
      }

      setInvoiceNumber(response?.data?.invoice?.code)
      setShowPdf(true)
      addAlert({
        message: 'Venta creada satisfactoriamente',
        status: 'success',
      })
    } catch (err) {
      addAlert({ message: 'Error al crear la venta', status: 'error' })
    }

    console.log('obj Body...', objBody)

    // axios.delete('www.se')

    // const objBody = {
    //   sale: {
    //     client: {
    //       id: selectedClient?.id,
    //     },
    //     payments: selectedMethods.map((method) => ({
    //       idAccount: method.id || '',
    //       amount: +method.amount,
    //       details: formatValueToSave(method)?.accountType,
    //       transactionType: method.type === 'Crédito' ? 'EXPENSES' : 'INCOME',
    //       receipt: method.ref || '',
    //       bills: method?.bills,
    //     })),
    //     unload: {
    //       destination: {
    //         id: '1',
    //         locationType: 'warehouse',
    //       },
    //       // items: selectedItems?.map((item) => ({
    //       //   idItem: item.id,
    //       //   amount: item.amount,
    //       // })),
    //       items: selectedItems?.reduce((a, b) => {
    //         a = [...a, { idItem: b.id, amount: b.amount }]
    //         if (b.type === 'COMPOUND' && b.compositionCompound) {
    //           a = [
    //             ...a,
    //             ...b.compositionCompound.map((v) => ({
    //               idItem: v.item.id,
    //               amount: b.amount,
    //             })),
    //           ]
    //         }
    //         return a
    //       }, [] as any),
    //     },
    //     invoice: {
    //       taxPrice: sumOfValues('iva').toFixed(2),
    //       tax: tax + '',
    //       taxBase: sumOfValues('sub_total').toFixed(2),
    //       subTotal:
    //         +sumOfValues('exempt').toFixed(2) +
    //         +sumOfValues('sub_total').toFixed(2),
    //       exempt: +sumOfValues('exempt').toFixed(2),
    //       total:
    //         +sumOfValues('sub_total').toFixed(2) +
    //         +sumOfValues('iva').toFixed(2) +
    //         +sumOfValues('exempt').toFixed(2),
    //       invoiceDetail: {
    //         invoiceNumber: '',
    //         items: selectedItems,
    //       },
    //     },
    //     deliveryNote: {},
    //     cashier: 'Gustavo Parra',
    //     seller: '1',
    //   },
    // }

    // let replaceValue = {
    //   á: 'a',
    //   é: 'é',
    //   í: 'i',
    //   ó: 'o',
    //   ú: 'u',
    // }

    // let objToInvoice = {
    //   invoice: {
    //     tax: '',
    //     tax_base: '',
    //     exempt: '',
    //     total: '',
    //     cashier: {
    //       seller: 'José Perez',
    //       safeBox: 'Caja 1',
    //     },
    //     client: {
    //       name: selectedClient?.name,
    //       surname: selectedClient?.surname,
    //       document: {
    //         document: selectedClient?.document,
    //         documentType: selectedClient?.documentType,
    //       },
    //       address: selectedClient?.address?.street,
    //       phone: selectedClient?.phones[0].number,
    //     },
    //     items: selectedItems?.map((item) => ({
    //       name: item.name.replace(/[áéíóú]/gi, (v) =>
    //         replaceValue[v.toLowerCase()].toUpperCase()
    //       ),
    //       amount: item.amount + '',
    //       price: !item.exempt
    //         ? (+item?.price[0]?.amount / Number(`1.${tax}`)).toFixed(2)
    //         : Number(item.price[0].amount).toFixed(2),
    //       exempt: item.exempt,
    //     })),
    //     payments: selectedMethods.map((method) => ({
    //       paymentMethod: paymentMethodType[method.type],
    //       amount: Number(method.amount).toFixed(2),
    //     })),
    //   },
    // }

    // let response = await axios.post('http://127.0.0.1:5000/api/factura', objToInvoice, config)

    // let debt = +(
    //   getTotalAmount() -
    //   +selectedMethods.reduce((a, b) => a + +b.amount, 0).toFixed(2)
    // ).toFixed(2)

    // let total_income = +selectedMethods
    //   .reduce((a, b) => a + +b.amount, 0)
    //   .toFixed(2)

    // if (debt === 0 && total_income === +getTotalAmount().toFixed(2)) {
    //   let headers = new Headers()
    //   headers.append('Content-Type', 'application/json')
    //   headers.append('Accept', 'application/json')

    //   addAlert({ message: 'Creando venta', status: 'loading' })
    //   fetch('http://127.0.0.1:5000/api/factura', {
    //     method: 'POST',
    //     mode: 'cors',
    //     body: JSON.stringify(objToInvoice),
    //     headers,
    //   })
    //     .then((v) => {
    //       return v.json()
    //     })
    //     .then(async (res) => {
    //       if (res?.Error) {
    //         addAlert({ message: res?.Error, status: 'error' })
    //         return
    //       }
    //       try {
    //         await axios.post(`${server}/business/sale/invoice`, {
    //           sale: {
    //             ...objBody.sale,
    //             invoice: {
    //               ...objBody.sale.invoice,
    //               invoiceDetail: {
    //                 ...objBody.sale.invoice.invoiceDetail,
    //                 invoiceNumber: res.invoice_number,
    //               },
    //             },
    //           },
    //         })
    //         setAlreadySelled(true)
    //         addAlert({ message: 'Venta creada con exito!', status: 'success' })
    //       } catch (err) {
    //         addAlert({ message: 'Error al crear una venta!', status: 'error' })
    //       }
    //     })
    //     .catch((err) => {
    //       addAlert({ message: 'Error con máquina fiscal', status: 'error' })
    //     })
    // } else {
    //   addAlert({
    //     message: 'El total ingresado es mayor a la deuda!',
    //     status: 'error',
    //   })
    // }
  }

  const onCreateDeliveryNote = async (): Promise<void> => {
    let objBody = {}

    // {
    //   "deliveryNote": {
    //     "client": {
    //       "id": "1"
    //     },
    //     "unload": {
    //       "destination": {
    //         "id": "1",
    //         "locationType": "warehouse"
    //       },
    //       "items": [
    //         {
    //           "idItem": "1",
    //           "amount": "1000"
    //         },
    //         {
    //           "idItem": "2",
    //           "amount": "1000"
    //         },
    //         {
    //           "idItem": "3",
    //           "amount": "1000"
    //         }
    //       ]
    //     },
    //     "deliveryNoteDetail": [
    //       {
    //         "amount": 1,
    //         "id": "2",
    //         "name": "HARINAA JUANA AMARILLA 1KGAAAAAAA",
    //         "description": "HARINA DE MAIZ",
    //         "sku": null,
    //         "barcode": "7591104102101",
    //         "exempt": false,
    //         "brand": "JUANA",
    //         "type": "NORMAL",
    //         "providers": {},
    //         "unit": {
    //           "id": "1",
    //           "name": "UNIDAD",
    //           "abbreviatedName": "und"
    //         },
    //         "inCatalog": false,
    //         "associatedCode": [],
    //         "compositionCompound": [],
    //         "assembly": [],
    //         "cost": [
    //           {
    //             "id": "2",
    //             "amount": "10.00",
    //             "id_item": "2",
    //             "date": "2022-03-16T15:51:13.268Z"
    //           }
    //         ],
    //         "price": [
    //           {
    //             "id": "2",
    //             "amount": "50.00",
    //             "date": "2022-03-16T15:51:13.268Z",
    //             "item": "2"
    //           }
    //         ],
    //         "batch": [],
    //         "images": [],
    //         "category": {
    //           "id": "1",
    //           "name": "SALSAS Y UNTABLES",
    //           "description": "SALSAS Y UNTABLES VARIOS",
    //           "code": "SU001",
    //           "children": [
    //             {
    //               "id": "1",
    //               "name": "MARGARINAS",
    //               "idCategory": "1",
    //               "code": "SUN001"
    //             },
    //             {
    //               "id": "2",
    //               "name": "MAYONESA",
    //               "idCategory": "1",
    //               "code": "SUM002"
    //             },
    //             {
    //               "id": "3",
    //               "name": "QUESOS",
    //               "idCategory": "1",
    //               "code": "SUQ003"
    //             }
    //           ]
    //         },
    //         "subcategory": {
    //           "id": "1",
    //           "name": "MARGARINAS",
    //           "idCategory": "1",
    //           "code": "SUN001"
    //         }
    //       },
    //       {
    //         "amount": 1,
    //         "id": "2",
    //         "name": "HARINAA JUANA AMARILLA 1KGAAAAAAA",
    //         "description": "HARINA DE MAIZ",
    //         "sku": null,
    //         "barcode": "7591104102101",
    //         "exempt": false,
    //         "brand": "JUANA",
    //         "type": "NORMAL",
    //         "providers": {},
    //         "unit": {
    //           "id": "1",
    //           "name": "UNIDAD",
    //           "abbreviatedName": "und"
    //         },
    //         "inCatalog": false,
    //         "associatedCode": [],
    //         "compositionCompound": [],
    //         "assembly": [],
    //         "cost": [
    //           {
    //             "id": "2",
    //             "amount": "10.00",
    //             "id_item": "2",
    //             "date": "2022-03-16T15:51:13.268Z"
    //           }
    //         ],
    //         "price": [
    //           {
    //             "id": "2",
    //             "amount": "50.00",
    //             "date": "2022-03-16T15:51:13.268Z",
    //             "item": "2"
    //           }
    //         ],
    //         "batch": [],
    //         "images": [],
    //         "category": {
    //           "id": "1",
    //           "name": "SALSAS Y UNTABLES",
    //           "description": "SALSAS Y UNTABLES VARIOS",
    //           "code": "SU001",
    //           "children": [
    //             {
    //               "id": "1",
    //               "name": "MARGARINAS",
    //               "idCategory": "1",
    //               "code": "SUN001"
    //             },
    //             {
    //               "id": "2",
    //               "name": "MAYONESA",
    //               "idCategory": "1",
    //               "code": "SUM002"
    //             },
    //             {
    //               "id": "3",
    //               "name": "QUESOS",
    //               "idCategory": "1",
    //               "code": "SUQ003"
    //             }
    //           ]
    //         },
    //         "subcategory": {
    //           "id": "1",
    //           "name": "MARGARINAS",
    //           "idCategory": "1",
    //           "code": "SUN001"
    //         }
    //       }
    //     ],
    //     "cashier": "Gustavo Parra",
    //     "totalPrice": 500.00,
    //     "paidOut": false,
    //     "type": "UNDISPATCHED",
    //     "receivableAccount": {
    //       "amount": 500.00,
    //       "client": {
    //         "id": "1"
    //       }
    //     },
    //     "payments": [
    //       {
    //         "idAccount": "1",
    //         "amount": 1000,
    //         "details": "CARD",
    //         "transactionType": "INCOME",
    //         "receipt": "123465789"
    //       }
    //     ]
    //   }
    // }

    if (isPayed) {
      objBody = {
        deliveryNote: {
          client: {
            id: selectedClient?.id,
          },
          //Details -> MOBILEPAYMENT / CASH / CARD / WALLET / WIRE TRANSFER
          // payments: [{
          //   idAccount: "1",
          //   amount: 10000,
          //   details: "CARD",
          //   transactionType: "INCOME",
          //   receipt: "132465789"
          // }],
          payments: selectedMethods.map((method) => ({
            idAccount: method.id,
            amount: +method.amount,
            details: formatValueToSave(method)?.accountType,
            transactionType: 'INCOME',
            receipt: method.ref,
            bills: method?.bills,
          })),
          unload: {
            destination: {
              id: '1',
              locationType: 'warehouse',
            },
            // items: selectedItems?.map((item) => ({
            //   idItem: item.id,
            //   amount: item.amount,
            // })),
            items: selectedItems?.reduce((a, b) => {
              a = [...a, { idItem: b.id, amount: b.amount }]
              if (b.type === 'COMPOUND' && b.compositionCompound) {
                a = [
                  ...a,
                  ...b.compositionCompound.map((v) => ({
                    idItem: v.item.id,
                    amount: b.amount,
                  })),
                ]
              }
              return a
            }, [] as any),
          },
          // invoice: {
          //   taxPrice: sumOfValues('iva').toFixed(2),
          //   tax: tax+"",
          //   taxBase: sumOfValues('sub_total').toFixed(2),
          //   subTotal: +sumOfValues('exempt').toFixed(2) + +sumOfValues('sub_total').toFixed(2) ,
          //   exempt: +sumOfValues('exempt').toFixed(2),
          //   total: +sumOfValues('sub_total').toFixed(2) + +sumOfValues('iva').toFixed(2) + +sumOfValues('exempt').toFixed(2),
          //   invoiceDetail: {
          //     invoiceNumber: '',
          //     items: selectedItems,
          //   },
          // },
          cashier: 'Gustavo Parra',
          deliveryNoteDetail: selectedItems,
          totalPrice: toFixed(
            sumOfValues('sub_total') + sumOfValues('exempt'),
            2
          ),
          // totalPrice: +(
          //   sumOfValues('sub_total') + sumOfValues('exempt')
          // ).toFixed(2),
          paidOut: isPayed,
          type: dispatchStatus,
        },
      }
    } else {
      objBody = {
        deliveryNote: {
          client: {
            id: selectedClient?.id,
          },
          //Details -> MOBILEPAYMENT / CASH / CARD / WALLET / WIRE TRANSFER
          // payments: [{
          //   idAccount: "1",
          //   amount: 10000,
          //   details: "CARD",
          //   transactionType: "INCOME",
          //   receipt: "132465789"
          // }],
          payments: selectedMethods.map((method) => ({
            idAccount: method.id,
            amount: +method.amount,
            details: formatValueToSave(method)?.accountType,
            transactionType: 'INCOME',
            receipt: method.ref,
            bills: method?.bills,
          })),
          unload: {
            destination: {
              id: '1',
              locationType: 'warehouse',
            },
            // items: selectedItems?.map((item) => ({
            //   idItem: item.id,
            //   amount: item.amount,
            // })),
            items: selectedItems?.reduce((a, b) => {
              a = [...a, { idItem: b.id, amount: b.amount }]
              if (b.type === 'COMPOUND' && b.compositionCompound) {
                a = [
                  ...a,
                  ...b.compositionCompound.map((v) => ({
                    idItem: v.item.id,
                    amount: b.amount,
                  })),
                ]
              }
              return a
            }, [] as any),
          },
          // invoice: {
          //   taxPrice: sumOfValues('iva').toFixed(2),
          //   tax: tax+"",
          //   taxBase: sumOfValues('sub_total').toFixed(2),
          //   subTotal: +sumOfValues('exempt').toFixed(2) + +sumOfValues('sub_total').toFixed(2) ,
          //   exempt: +sumOfValues('exempt').toFixed(2),
          //   total: +sumOfValues('sub_total').toFixed(2) + +sumOfValues('iva').toFixed(2) + +sumOfValues('exempt').toFixed(2),
          //   invoiceDetail: {
          //     invoiceNumber: '',
          //     items: selectedItems,
          //   },
          // },
          deliveryNoteDetail: selectedItems,
          cashier: 'Gustavo Parra',
          // totalPrice: +(
          //   sumOfValues('sub_total') + sumOfValues('exempt')
          // ).toFixed(2),
          totalPrice: toFixed(
            sumOfValues('sub_total') + sumOfValues('exempt'),
            2
          ),
          paidOut: isPayed,
          type: dispatchStatus,
          receivableAccount: {
            // amount: +(
            //   +(sumOfValues('sub_total') + sumOfValues('exempt')).toFixed(2) -
            //   +selectedMethods.reduce((a, b) => a + +b.amount, 0).toFixed(2)
            // ).toFixed(2),
            amount: toFixed(
              sumOfValues('sub_total') +
                sumOfValues('exempt') -
                +selectedMethods.reduce((a, b) => a + +b.amount, 0),
              2
            ),
            client: {
              id: selectedClient?.id,
            },
          },
        },
      }
    }

    console.log('obj body', objBody)
    addAlert({ message: 'Creando una nota de entrega', status: 'loading' })
    try {
      let resp = await axios.post(`${server}/business/delivery-note`, objBody)
      addAlert({
        message: 'Nota de entrega creada con exito!',
        status: 'success',
      })
      setAlreadySelled(true)
      setShowPdfDeliveryNote(true)
      setCorrelativeNumber(resp.data.newDeliveryNote.correlativeNumber)
    } catch (err) {
      addAlert({
        message: 'Error al crear una nota de entrega!',
        status: 'error',
      })
    }
  }

  const onCreateSellByFreeForm = async (): Promise<void> => {
    console.log('selectedmethods', selectedMethods)

    const objBody = {
      sale: {
        client: {
          id: selectedClient?.id,
        },
        payments: selectedMethods.map((method) => ({
          idAccount: method.id || '',
          amount: +method.amount || '',
          details: formatValueToSave(method)?.accountType,
          transactionType: method.type === 'Crédito' ? 'EXPENSES' : 'INCOME',
          receipt: method.ref || '',
          bills: method?.bills,
          // bills: method.accountType === 'CASH' ? stateBills.map(bill => ({quantity: bill.quantity, amount: bill.amountCash})) : undefined
        })),
        unload: {
          destination: {
            id: '1',
            locationType: 'warehouse',
          },
          items: selectedItems?.reduce((a, b) => {
            a = [...a, { idItem: b.id, amount: b.amount }]
            if (b.type === 'COMPOUND' && b.compositionCompound) {
              a = [
                ...a,
                ...b.compositionCompound.map((v) => ({
                  idItem: v.item.id,
                  amount: b.amount,
                })),
              ]
            }
            return a
          }, [] as any),
        },
        freeForm: {
          // taxPrice: sumOfValues('iva').toFixed(2),
          taxPrice: toFixed(sumOfValues('iva'), 2),
          tax: tax + '',
          // taxBase: sumOfValues('sub_total').toFixed(2),
          taxBase: toFixed(sumOfValues('sub_total'), 2),
          // subTotal:
          //   +sumOfValues('exempt').toFixed(2) +
          //   +sumOfValues('sub_total').toFixed(2),
          subTotal: toFixed(
            sumOfValues('exempt') + sumOfValues('sub_total'),
            2
          ),
          // exempt: +sumOfValues('exempt').toFixed(2),
          exempt: toFixed(sumOfValues('exempt'), 2),
          // total:
          //   +sumOfValues('sub_total').toFixed(2) +
          //   +sumOfValues('iva').toFixed(2) +
          //   +sumOfValues('exempt').toFixed(2),
          total: toFixed(
            sumOfValues('sub_total') +
              sumOfValues('iva') +
              sumOfValues('exempt'),
            2
          ),
          freeFormDetail: {
            items: selectedItems,
          },
        },
        deliveryNote: {},
        cashier: 'Gustavo Parra',
        seller: 'Gustavo Parra',
      },
    }

    // let debt = +(
    //   getTotalAmount() -
    //   +selectedMethods.reduce((a, b) => a + +b.amount, 0).toFixed(2)
    // ).toFixed(2)
    let debt = +toFixed(
      getTotalAmount() - +selectedMethods.reduce((a, b) => a + +b.amount, 0),
      2
    )
    // let total_income = +selectedMethods
    //   .reduce((a, b) => a + +b.amount, 0)
    //   .toFixed(2)

    let total_income = +toFixed(
      +selectedMethods.reduce((a, b) => a + +b.amount, 0),
      2
    )

    if (debt === 0 && total_income === +toFixed(getTotalAmount(), 2)) {
      try {
        addAlert({ message: 'Creando venta', status: 'loading' })
        /* Peticion */
        let resp = await axios.post(`${server}/business/sale/free-form`, {
          sale: {
            ...objBody.sale,
            freeForm: {
              ...objBody.sale.freeForm,
              freeFormDetail: {
                ...objBody.sale.freeForm.freeFormDetail,
                controlNumber: uuidv4().slice(0, 6),
              },
            },
          },
        })
        setCorrelativeNumber(resp.data.newSaleByFreeForm.correlativeNumber)
        setShowPdf(true)

        addAlert({ message: 'Venta creada con exito!', status: 'success' })
      } catch (err) {
        addAlert({ message: 'Error al crear una venta!', status: 'error' })
      }
    } else {
      addAlert({
        message: 'El total ingresado es mayor a la deuda!',
        status: 'error',
      })
    }
  }

  const onCreateFreeFormFromPending = async (): Promise<void> => {
    const objBody = {
      sale: {
        id: selldId,
        client: {
          id: selectedClient?.id,
        },
        payments: selectedMethods.map((method) => ({
          idAccount: method.id,
          amount: +method.amount,
          details: formatValueToSave(method)?.accountType,
          transactionType: 'INCOME',
          receipt: method.ref,
          paymentStatus: method.paymentStatus,
          idTransaction: method.idTransaction,
        })),
        unload: {
          destination: {
            id: '1',
            locationType: 'warehouse',
          },
          items: selectedItems?.reduce((a, b) => {
            a = [...a, { idItem: b.id, amount: b.amount }]
            if (b.type === 'COMPOUND' && b.compositionCompound) {
              a = [
                ...a,
                ...b.compositionCompound.map((v) => ({
                  idItem: v.item.id,
                  amount: b.amount,
                })),
              ]
            }
            return a
          }, [] as any),
        },
        freeForm: {
          // taxPrice: sumOfValues('iva').toFixed(2),
          taxPrice: toFixed(sumOfValues('iva'), 2),
          tax: tax + '',
          // taxBase: sumOfValues('sub_total').toFixed(2),
          taxBase: toFixed(sumOfValues('sub_total'), 2),
          // subTotal:
          //   +sumOfValues('exempt').toFixed(2) +
          //   +sumOfValues('sub_total').toFixed(2),
          subTotal: toFixed(
            sumOfValues('exempt') + sumOfValues('sub_total'),
            2
          ),
          // exempt: +sumOfValues('exempt').toFixed(2),
          exempt: toFixed(sumOfValues('exempt'), 2),
          // total:
          //   +sumOfValues('sub_total').toFixed(2) +
          //   +sumOfValues('iva').toFixed(2) +
          //   +sumOfValues('exempt').toFixed(2),
          total: toFixed(
            sumOfValues('sub_total') +
              sumOfValues('iva') +
              sumOfValues('exempt'),
            2
          ),
          freeFormDetail: {
            items: selectedItems,
          },
        },
        cashier: 'Gustavo Parra',
        seller: 'Gustavo Parra',
      },
    }

    // let debt = +(
    //   getTotalAmount() -
    //   +selectedMethods.reduce((a, b) => a + +b.amount, 0).toFixed(2)
    // ).toFixed(2)
    // let total_income = +selectedMethods
    //   .reduce((a, b) => a + +b.amount, 0)
    //   .toFixed(2)

    // let debt = +(
    //   getTotalAmount() -
    //   +selectedMethods.reduce((a, b) => a + +b.amount, 0).toFixed(2)
    // ).toFixed(2)
    let debt = +toFixed(
      getTotalAmount() - +selectedMethods.reduce((a, b) => a + +b.amount, 0),
      2
    )
    // let total_income = +selectedMethods
    //   .reduce((a, b) => a + +b.amount, 0)
    //   .toFixed(2)

    let total_income = +toFixed(
      +selectedMethods.reduce((a, b) => a + +b.amount, 0),
      2
    )

    if (debt === 0 && total_income === +toFixed(getTotalAmount(), 2)) {
      try {
        addAlert({ message: 'Creando venta', status: 'loading' })
        /* Peticion */
        let resp = await axios.patch(
          `${server}/business/sale/pending/free-form`,
          {
            sale: {
              ...objBody.sale,
              freeForm: {
                ...objBody.sale.freeForm,
                freeFormDetail: {
                  ...objBody.sale.freeForm.freeFormDetail,
                },
              },
            },
          }
        )
        setCorrelativeNumber(resp.data.newSale.correlativeNumber)
        setShowPdf(true)
        addAlert({ message: 'Venta creada con exito!', status: 'success' })
      } catch (err) {
        addAlert({ message: 'Error al crear una venta!', status: 'error' })
      }
    } else {
      addAlert({
        message: 'El total ingresado es mayor a la deuda!',
        status: 'error',
      })
    }
  }

  const onConvertToInvoiceSale = async (): Promise<void> => {
    let paymentMethodType = {
      'Billetera Virtual': 'WALLET',
      'Cuenta Bancaria': 'TRANSFERENCE',
      Efectivo: 'CASH',
      'Punto de venta': 'CARD',
      'Pago Móvil': 'MOBILE PAYMENT',
    }

    console.log('ispayed', paidOut)

    const entity = {
      entity: {
        client: {
          id: selectedClient?.id,
        },
        //Details -> MOBILEPAYMENT / CASH / CARD / WALLET / WIRE TRANSFER
        // payments: [{
        //   idAccount: "1",
        //   amount: 10000,
        //   details: "CARD",
        //   transactionType: "INCOME",
        //   receipt: "132465789"
        // }],
        payments: selectedMethods.map((method) => ({
          idAccount: method.id,
          amount: +method.amount,
          details: formatValueToSave(method)?.accountType,
          transactionType: 'INCOME',
          receipt: method.ref,
          paymentStatus:
            method.paymentStatus === TypeStatus.DONE
              ? TypeStatus.DONE
              : TypeStatus.UNDONE,
        })),
        unload: {
          destination: {
            id: '1',
            locationType: 'warehouse',
          },
          // items: selectedItems?.map((item) => ({
          //   idItem: item.id,
          //   amount: item.amount,
          // })),
          items: selectedItems?.reduce((a, b) => {
            a = [
              ...a,
              { idItem: b.id, amount: b.amount, updated: b.updated || false },
            ]
            if (b.type === 'COMPOUND' && b.compositionCompound) {
              a = [
                ...a,
                ...b.compositionCompound.map((v) => ({
                  idItem: v.item.id,
                  amount: b.amount,
                  updated: b.updated || false,
                })),
              ]
            }
            return a
          }, [] as any),
        },
        deliveryNote: {
          id: selldId,
          paidOut: !paidOut
            ? undefined
            : +toFixed(
                getTotalAmount() -
                  +selectedMethods.reduce((a, b) => a + +b.amount, 0),
                2
              ) === 0 || paidOut,
          type:
            +toFixed(
              getTotalAmount() -
                +selectedMethods.reduce((a, b) => a + +b.amount, 0),
              2
            ) === 0
              ? 'DISPATCHED'
              : dispatchStatusProps,
          // +(
          //   getTotalAmount() -
          //   +selectedMethods.reduce((a, b) => a + +b.amount, 0).toFixed(2)
          // ).toFixed(2) === 0
          //   ? 'DISPATCHED'
          //   : dispatchStatusProps,
        },
        invoice: {
          // taxPrice: sumOfValues('iva').toFixed(2),
          taxPrice: toFixed(sumOfValues('iva'), 2),
          tax: tax + '',
          // taxBase: sumOfValues('sub_total').toFixed(2),
          taxBase: toFixed(sumOfValues('sub_total'), 2),
          // subTotal:
          //   +sumOfValues('exempt').toFixed(2) +
          //   +sumOfValues('sub_total').toFixed(2),
          subTotal: toFixed(
            sumOfValues('exempt') + sumOfValues('sub_total'),
            2
          ),
          // exempt: +sumOfValues('exempt').toFixed(2),
          exempt: toFixed(sumOfValues('exempt'), 2),
          // total:
          //   +sumOfValues('sub_total').toFixed(2) +
          //   +sumOfValues('iva').toFixed(2) +
          //   +sumOfValues('exempt').toFixed(2),
          total: toFixed(
            sumOfValues('sub_total') +
              sumOfValues('iva') +
              sumOfValues('exempt'),
            2
          ),
          invoiceDetail: {
            invoiceNumber: '',
            items: selectedItems,
          },
        },
        cashier: 'Gustavo Parra',
        seller: 'Gustavo Parra',
        // totalPrice:
        //   +sumOfValues('sub_total').toFixed(2) +
        //   +sumOfValues('iva').toFixed(2) +
        //   +sumOfValues('exempt').toFixed(2),
        totalPrice: toFixed(
          sumOfValues('sub_total') + sumOfValues('iva') + sumOfValues('exempt'),
          2
        ),
        saleType: 'INVOICE',
      },
    }

    console.log('convert invoice sale', entity)

    let replaceValue = {
      á: 'a',
      é: 'é',
      í: 'i',
      ó: 'o',
      ú: 'u',
    }

    // let objToInvoice = {
    //   invoice: {
    //     tax: '',
    //     tax_base: '',
    //     exempt: '',
    //     total: '',
    //     cashier: {
    //       seller: 'José Perez',
    //       safeBox: 'Caja 1',
    //     },
    //     client: {
    //       name: selectedClient?.name,
    //       surname: selectedClient?.surname,
    //       document: {
    //         document: selectedClient?.document,
    //         documentType: selectedClient?.documentType,
    //       },
    //       address: selectedClient?.address?.street,
    //       phone: selectedClient?.phones[0].number,
    //     },
    //     items: selectedItems?.map((item) => ({
    //       name: item.name.replace(/[áéíóú]/gi, (v) =>
    //         replaceValue[v.toLowerCase()].toUpperCase()
    //       ),
    //       amount: item.amount + '',
    //       price: !item.exempt
    //         ? (+item?.price[0]?.amount / Number(`1.${tax}`)).toFixed(2)
    //         : Number(item.price[0].amount).toFixed(2),
    //       exempt: item.exempt,
    //     })),
    //     payments: selectedMethods.map((method) => ({
    //       paymentMethod: paymentMethodType[method.type],
    //       amount: Number(method.amount).toFixed(2),
    //     })),
    //   },
    // }

    // let debt = +(
    //   getTotalAmount() -
    //   +selectedMethods.reduce((a, b) => a + +b.amount, 0).toFixed(2)
    // ).toFixed(2)

    // let total_income = +selectedMethods
    //   .reduce((a, b) => a + +b.amount, 0)
    //   .toFixed(2)

    let debt = +toFixed(
      getTotalAmount() - +selectedMethods.reduce((a, b) => a + +b.amount, 0),
      2
    )
    // let total_income = +selectedMethods
    //   .reduce((a, b) => a + +b.amount, 0)
    //   .toFixed(2)

    let total_income = +toFixed(
      +selectedMethods.reduce((a, b) => a + +b.amount, 0),
      2
    )

    if (debt === 0 && total_income === +toFixed(getTotalAmount(), 2)) {
      let headers = new Headers()
      headers.append('Content-Type', 'application/json')
      headers.append('Accept', 'application/json')

      addAlert({ message: 'Creando venta', status: 'loading' })
      fetch('http://127.0.0.1:5000/api/factura', {
        method: 'POST',
        mode: 'cors',
        // body: JSON.stringify(objToInvoice),
        headers,
      })
        .then((v) => {
          return v.json()
        })
        .then(async (res) => {
          if (res?.Error) {
            addAlert({ message: res?.Error, status: 'error' })
            return
          }
          try {
            await axios.post(`${server}/business/delivery-note/sale`, {
              entity: {
                ...entity.entity,
                invoice: {
                  ...entity.entity.invoice,
                  invoiceDetail: {
                    ...entity.entity.invoice.invoiceDetail,
                    invoiceNumber: res.invoice_number,
                  },
                },
              },
            })
            setAlreadySelled(true)
            addAlert({ message: 'Venta creada con exito!', status: 'success' })
            setFinishedDeliveryToSale(true)
          } catch (err) {
            addAlert({ message: 'Error al crear una venta!', status: 'error' })
          }
        })
        .catch((err) => {
          addAlert({ message: 'Error con máquina fiscal', status: 'error' })
        })
    } else {
      addAlert({
        message: 'El total ingresado es mayor a la deuda!',
        status: 'error',
      })
    }
  }

  const onConvertPendingDeliveryNote = async (): Promise<void> => {
    const objBody = {
      deliveryNote: {
        id: selldId,
        client: {
          id: selectedClient?.id,
        },
        //Details -> MOBILEPAYMENT / CASH / CARD / WALLET / WIRE TRANSFER
        payments: selectedMethods.map((method) => ({
          idAccount: method.id,
          amount: +method.amount,
          details: formatValueToSave(method)?.accountType,
          transactionType: 'INCOME',
          receipt: '12345678',
          paymentStatus: method.paymentStatus,
          idTransaction: method.idTransaction,
        })),
        unload: {
          destination: {
            id: '1',
            locationType: 'warehouse',
          },
          items: selectedItems?.map((item) => ({
            idItem: item.id,
            amount: item.amount,
          })),
        },
        cashier: 'Gustavo Parra',
        seller: 'Gustavo Parra',
        // totalPrice:
        //   +sumOfValues('sub_total').toFixed(2) +
        //   +sumOfValues('iva').toFixed(2) +
        //   +sumOfValues('exempt').toFixed(2),
        totalPrice: toFixed(
          sumOfValues('sub_total') + sumOfValues('iva') + sumOfValues('exempt'),
          2
        ),
        paidOut: isPayed,
        type: dispatchStatus,
      },
    }

    addAlert({ message: 'Creando nota de entrega...', status: 'loading' })
    try {
      await axios.patch(`${server}/business/delivery-note/pending`, objBody)
      addAlert({
        message: 'Nota de entrega creada con exito!',
        status: 'success',
      })
      setAlreadySelled(true)
    } catch (err) {
      addAlert({ message: 'Error al crear nota de entrega!', status: 'error' })
    } finally {
    }
  }

  const onConvertToFreeFormSale = async () => {
    const entity = {
      entity: {
        client: {
          id: selectedClient?.id,
        },
        //Details -> MOBILEPAYMENT / CASH / CARD / WALLET / WIRE TRANSFER
        // payments: [{
        //   idAccount: "1",
        //   amount: 10000,
        //   details: "CARD",
        //   transactionType: "INCOME",
        //   receipt: "132465789"
        // }],
        payments: selectedMethods.map((method) => ({
          idAccount: method.id,
          amount: +method.amount,
          details: formatValueToSave(method)?.accountType,
          transactionType: 'INCOME',
          receipt: method.ref,
        })),
        unload: {
          destination: {
            id: '1',
            locationType: 'warehouse',
          },
          // items: selectedItems?.map((item) => ({
          //   idItem: item.id,
          //   amount: item.amount,
          // })),
          items: selectedItems?.reduce((a, b) => {
            a = [
              ...a,
              { idItem: b.id, amount: b.amount, updated: b.updated || false },
            ]
            if (b.type === 'COMPOUND' && b.compositionCompound) {
              a = [
                ...a,
                ...b.compositionCompound.map((v) => ({
                  idItem: v.item.id,
                  amount: b.amount,
                  updated: b.updated || false,
                })),
              ]
            }
            return a
          }, [] as any),
        },
        deliveryNote: {
          id: selldId,
          paidOut:
            +toFixed(
              getTotalAmount() -
                +selectedMethods.reduce((a, b) => a + +b.amount, 0),
              2
            ) === 0 || paidOut,
          // +(
          //   getTotalAmount() -
          //   +selectedMethods.reduce((a, b) => a + +b.amount, 0).toFixed(2)
          // ).toFixed(2) === 0 || paidOut,
          type:
            +toFixed(
              getTotalAmount() -
                +selectedMethods.reduce((a, b) => a + +b.amount, 0),
              2
            ) === 0
              ? 'DISPATCHED'
              : dispatchStatusProps,
          // +(
          //   getTotalAmount() -
          //   +selectedMethods.reduce((a, b) => a + +b.amount, 0).toFixed(2)
          // ).toFixed(2) === 0
          //   ? 'DISPATCHED'
          //   : dispatchStatusProps,
        },
        freeForm: {
          // taxPrice: sumOfValues('iva').toFixed(2),
          taxPrice: toFixed(sumOfValues('iva'), 2),
          tax: tax + '',
          // taxBase: sumOfValues('sub_total').toFixed(2),
          taxBase: toFixed(sumOfValues('sub_total'), 2),
          // subTotal:
          //   +sumOfValues('exempt').toFixed(2) +
          //   +sumOfValues('sub_total').toFixed(2),
          subTotal: toFixed(
            sumOfValues('exempt') + sumOfValues('sub_total'),
            2
          ),
          // exempt: +sumOfValues('exempt').toFixed(2),
          exempt: toFixed(sumOfValues('exempt'), 2),
          // total:
          //   +sumOfValues('sub_total').toFixed(2) +
          //   +sumOfValues('iva').toFixed(2) +
          //   +sumOfValues('exempt').toFixed(2),
          total: toFixed(
            sumOfValues('sub_total') +
              sumOfValues('iva') +
              sumOfValues('exempt'),
            2
          ),
          freeFormDetail: {
            items: selectedItems,
          },
        },
        cashier: 'Gustavo Parra',
        // seller: null,
        // totalPrice:
        //   +sumOfValues('sub_total').toFixed(2) +
        //   +sumOfValues('iva').toFixed(2) +
        //   +sumOfValues('exempt').toFixed(2),
        totalPrice: toFixed(
          sumOfValues('sub_total') + sumOfValues('iva') + sumOfValues('exempt'),
          2
        ),
        saleType: 'FREE_FORM',
      },
    }
    console.log('free form....')

    addAlert({ message: 'Creando venta', status: 'loading' })
    try {
      let resp = await axios.post(
        `${server}/business/delivery-note/sale`,
        entity
      )
      // setAlreadySelled(true)
      addAlert({ message: 'Venta creada con exito!', status: 'success' })
      setCorrelativeNumber(resp.data.newDeliveryNote.correlativeNumber)
      setShowPdf(true)
    } catch (err) {
      addAlert({ message: 'Error al crear una venta!', status: 'error' })
    } finally {
    }
  }

  const onEditSale = async (): Promise<void> => {
    let paymentMethodType = {
      'Billetera Virtual': 'WALLET',
      'Cuenta Bancaria': 'TRANSFERENCE',
      Efectivo: 'CASH',
      'Punto de venta': 'CARD',
    }

    if (isPaymentMethod) {
      console.log('method', selectedMethods)
      const objBody = {
        sale: {
          id: selldId,
          client: {
            id: selectedClient?.id,
          },
          //Details -> MOBILEPAYMENT / CASH / CARD / WALLET / WIRE TRANSFER
          payments: selectedMethods.map((method) => ({
            idAccount: method.id,
            amount: +method.amount,
            details: formatValueToSave(method)?.accountType,
            transactionType: 'INCOME',
            receipt: '12345678',
            paymentStatus: method.paymentStatus,
            idTransaction: method.idTransaction,
          })),
          unload: {
            destination: {
              id: '1',
              locationType: 'warehouse',
            },
            items: selectedItems?.map((item) => ({
              idItem: item.id,
              amount: item.amount,
            })),
          },
          invoice: {
            // taxPrice: sumOfValues('iva').toFixed(2),
            taxPrice: toFixed(sumOfValues('iva'), 2),
            tax: tax + '',
            // taxBase: sumOfValues('sub_total').toFixed(2),
            taxBase: toFixed(sumOfValues('sub_total'), 2),
            // subTotal:
            //   +sumOfValues('exempt').toFixed(2) +
            //   +sumOfValues('sub_total').toFixed(2),
            subTotal: toFixed(
              sumOfValues('exempt') + sumOfValues('sub_total'),
              2
            ),
            // exempt: +sumOfValues('exempt').toFixed(2),
            exempt: toFixed(sumOfValues('exempt'), 2),
            // total:
            //   +sumOfValues('sub_total').toFixed(2) +
            //   +sumOfValues('iva').toFixed(2) +
            //   +sumOfValues('exempt').toFixed(2),
            total: toFixed(
              sumOfValues('sub_total') +
                sumOfValues('iva') +
                sumOfValues('exempt'),
              2
            ),
            invoiceDetail: {
              invoiceNumber: '100',
              items: selectedItems,
            },
          },
          cashier: 'Gustavo Parra',
          seller: 'Gustavo Parra',
        },
      }

      let replaceValue = {
        á: 'a',
        é: 'é',
        í: 'i',
        ó: 'o',
        ú: 'u',
      }

      // let objToInvoice = {
      //   invoice: {
      //     tax: '',
      //     tax_base: '',
      //     exempt: '',
      //     total: '',
      //     cashier: {
      //       seller: 'José Perez',
      //       safeBox: 'Caja 1',
      //     },
      //     client: {
      //       name: selectedClient?.name,
      //       surname: selectedClient?.surname,
      //       document: {
      //         document: selectedClient?.document,
      //         documentType: selectedClient?.documentType,
      //       },
      //       address: selectedClient?.address?.street,
      //       phone: selectedClient?.phones[0].number,
      //     },
      //     items: selectedItems?.map((item) => ({
      //       name: item.name.replace(/[áéíóú]/gi, (v) =>
      //         replaceValue[v.toLowerCase()].toUpperCase()
      //       ),
      //       amount: item.amount + '',
      //       // price: !item.exempt
      //       //   ? (+item?.price[0]?.amount / Number(`1.${tax}`)).toFixed(2)
      //       //   : Number(item.price[0].amount).toFixed(2),
      //       exempt: item.exempt,
      //     })),
      //     payments: selectedMethods.map((method) => ({
      //       paymentMethod: paymentMethodType[method.type],
      //       amount: Number(method.amount).toFixed(2),
      //     })),
      //   },
      // }

      // let debt = +(
      //   getTotalAmount() -
      //   +selectedMethods.reduce((a, b) => a + +b.amount, 0).toFixed(2)
      // ).toFixed(2)

      // let total_income = +selectedMethods
      //   .reduce((a, b) => a + +b.amount, 0)
      //   .toFixed(2)

      let debt = +toFixed(
        +toFixed(getTotalAmount(), 2) -
          +toFixed(+selectedMethods.reduce((a, b) => a + +b.amount, 0), 2),
        2
      )
      // let total_income = +selectedMethods
      //   .reduce((a, b) => a + +b.amount, 0)
      //   .toFixed(2)

      let total_income = +toFixed(
        +selectedMethods.reduce((a, b) => a + +b.amount, 0),
        2
      )

      if (debt === 0 && total_income === +toFixed(getTotalAmount(), 2)) {
        let headers = new Headers()
        headers.append('Content-Type', 'application/json')
        headers.append('Accept', 'application/json')

        addAlert({ message: 'Creando venta', status: 'loading' })
        fetch('http://127.0.0.1:5000/api/factura', {
          method: 'POST',
          mode: 'cors',
          // body: JSON.stringify(objToInvoice),
          headers: headers,
        })
          .then((v) => {
            return v.json()
          })
          .then(async (res) => {
            if (res?.Error) {
              addAlert({ message: res?.Error, status: 'error' })
              return
            }
            try {
              await axios.patch(`${server}/business/sale/pending/invoice`, {
                sale: {
                  ...objBody.sale,
                  invoice: {
                    ...objBody.sale.invoice,
                    invoiceDetail: {
                      ...objBody.sale.invoice.invoiceDetail,
                      invoiceNumber: res.invoice_number,
                    },
                  },
                },
              })
              setAlreadySelled(true)
              addAlert({
                message: 'Venta creada con exito!',
                status: 'success',
              })
            } catch (err) {
              addAlert({
                message: 'Error al crear una venta!',
                status: 'error',
              })
            }
          })
          .catch((err) => {
            addAlert({ message: 'Error con máquina fiscal', status: 'error' })
          })
      } else {
        addAlert({
          message: 'El total ingresado es mayor a la deuda!',
          status: 'error',
        })
      }
    } else {
      setIsPaymentMethod(true)
    }
  }

  useEffect(() => {
    if (
      (status === 'PENDING' ||
        status === 'REFUND' ||
        status === 'DELIVERY_NOTE_TO_SALE' ||
        status === 'PENDING_DELIVERY') &&
      payment_methods.length !== 0
    ) {
      setIsPaymentMethod(true)
    }
  }, [])

  const columnsSearchItems: ColumnsTable[] = [
    {
      title: 'Nombre',
      dataIndex: 'item.name',
      key: 'item.name',
    },
    {
      title: 'SKU',
      dataIndex: 'item.sku',
      key: 'item.sku',
      render: (id: number, record: any) => (
        <ColumnItemWrapper
          subElement="paragraph"
          subElementStyle={`${record?.item.sku ? '' : 'text-gray-600'}`}
        >
          {record?.item.sku || 'N/A'}
        </ColumnItemWrapper>
      ),
      width: 50,
    },
    {
      title: 'Código',
      dataIndex: 'item.barcode',
      key: 'item.barcode',
      render: (id: number, record: any) => (
        <ColumnItemWrapper
          subElement="paragraph"
          subElementStyle={`${record?.item.barcode ? '' : 'text-gray-600'}`}
        >
          {record?.item.barcode || 'N/A'}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Precio',
      dataIndex: 'item.price',
      key: 'item.price',
      render: (id: number, record: any) => (
        <ColumnItemWrapper>
          <p
            className={`${
              !(record?.item.price.length > 0) ? 'text-warning' : 'text-success'
            }`}
          >
            {record?.item.price.length > 0 ? (
              'Bs ' + record?.item.price[0]?.amount
            ) : (
              <span>
                Sin Precio <FiAlertTriangle className="text-warning inline" />
              </span>
            )}
          </p>
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Categoría',
      dataIndex: 'item.category.name',
      key: 'item.category.name',
    },
    {
      title: 'Disponibilidad',
      dataIndex: 'quantity',
      key: 'quantity',
    },
  ]

  const columnsSearchClients: ColumnsTable[] = [
    {
      title: 'NOMBRE',
      dataIndex: 'name',
      key: 'name',
      render: (x: any, client: any) => (
        <ColumnItemWrapper>{client?.name?.toUpperCase()}</ColumnItemWrapper>
      ),
    },
    // {
    //   title: 'Teléfono',
    //   dataIndex: 'phone',
    //   key: 'phone',
    //   width: 140,
    //   render: (x: any, client: any) => (
    //     <ColumnItemWrapper>
    //       {/* <div> */}
    //       <p
    //         style={{
    //           whiteSpace: 'pre',
    //           overflow: 'hidden',
    //           textOverflow: 'ellipsis',
    //         }}
    //       >
    //         {client?.phones
    //           .map(
    //             (phone, i) =>
    //               `${phone.country.dialCode || phone.country.dial_code} ${
    //                 phone.number
    //               }`
    //           )
    //           .join('\n')}
    //       </p>
    //       {/* </div> */}
    //     </ColumnItemWrapper>
    //   ),
    // },
    {
      title: 'DOCUMENTO',
      dataIndex: 'document',
      key: 'document',
      render: (x: any, client: any) => (
        <ColumnItemWrapper>
          {client?.documentType}-{client.document}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'CORREO',
      dataIndex: 'email',
      key: 'email',
      render: (x: any, client: any) => (
        <ColumnItemWrapper>{client?.email?.toUpperCase()}</ColumnItemWrapper>
      ),
    },
  ]

  const columnsSearchInSell: ColumnsTable[] = [
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
      tootltipValue: true,
    },
    {
      title: 'Código',
      dataIndex: 'sku',
      key: 'sku',
      render: (id: number, record: any) => (
        <ColumnItemWrapper
          subElement="paragraph"
          subElementStyle={`${record?.sku ? '' : 'text-gray-600'}`}
        >
          {record?.sku || 'N/A'}
        </ColumnItemWrapper>
      ),
      width: 50,
    },
    {
      title: 'Precio',
      dataIndex: 'price',
      key: 'price',
      render: (id: number, record: any) => (
        <ColumnItemWrapper>
          <p>
            {`${getDenomination(record?.currency?.id)} ${formatPipe(
              record?.price
            )}`}
          </p>
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Categoría',
      dataIndex: 'category.name',
      key: 'category.name',
      render: (id: number, record: any) => (
        <ColumnItemWrapper>
          <p>{record?.category?.name || 'N/A'}</p>
        </ColumnItemWrapper>
      ),
    },
  ]

  // const getItems = async () => {
  //   let response = await axios.get<{ items: IItem[] }>(
  //     `${server}/inventory/item/search/custom?searchCustom=${refCode.current?.value}`
  //   )
  //   setSearchItems(response.data.items)
  // }

  // useEffect(() => {
  //   if (selectedClient) {
  //     // let response = await axios.get<{ items: IItem[] }>(
  //     //   `${server}/inventory/item/search/custom?searchCustom=${refCode.current?.value}`
  //     // )
  //     getItems()
  //   }
  // }, [selectedClient])

  const onFilterActions = (headerActions) => {
    if (status === 'DELIVERY_NOTE_TO_SALE') {
      const { searchItems, onPending, ...rest } = headerActions
      return rest
    }
    if (status === 'PENDING') {
      const { onFreeForm, ...rest } = headerActions
      return rest
    }
    if (status === 'DELIVERY_NOTE' || status === 'PENDING_DELIVERY') {
      const { searchItems, onFreeForm, ...rest } = headerActions
      return {
        ...rest,
        onPayed: (checked, setCheckedPayed) => {
          if (selectedMethods.length > 0) {
            // {status === 'DELIVERY_NOTE' || status === 'PENDING_DELIVERY'
            //           ? (sumOfValues('sub_total') - +selectedMethods
            //           .reduce((a, b) => a + +b.amount, 0)).toFixed(2)
            //           : (getTotalAmount() - +selectedMethods
            //               .reduce((a, b) => a + +b.amount, 0)).toFixed(2)}
            console.log(
              'sub_total',
              sumOfValues('sub_total') + sumOfValues('exempt')
            )
            let value = +toFixed(
              +toFixed(sumOfValues('sub_total'), 2) +
                +toFixed(sumOfValues('exempt'), 2) -
                +toFixed(
                  +selectedMethods.reduce((a, b) => a + +b.amount, 0),
                  2
                ),
              2
            )
            if (value === 0) {
              setCheckedPayed(true)
              setIsPayed(true)
            } else {
              setCheckedPayed(false)
              setIsPayed(false)
            }
          } else {
            setIsPayed(checked)
          }
        },
        onChangeDeliveryStatus: (value) => {
          setDispatchStatus(value)
        },
      }
    }
    return headerActions
  }

  useEffect(() => {
    setHeaderActions(
      {
        onShowRate: () => {},
      }
      // onFilterActions({
      // searchItems: (value: string) => {
      //   setItemToSearch(value)
      // },
      // onPending: () => {
      //   onCreatePendingSell()
      // },
      // onChangeSaleType: (value) => {
      //   // console.log("value...", value)
      //   setStatus(value)
      // },
      // onFreeForm: (v, setCheckedSale) => {
      //   setIsFreeForm(v)
      //   if (status === 'PENDING' && type === 'FREE FORM') {
      //     setCheckedSale(true)
      //     setIsFreeForm(true)
      //   } else {
      //     if (!alreadyInitialized.current) {
      //       alreadyInitialized.current = true
      //       setCheckedSale(false)
      //     }
      //   }
      // },
      // onChangeToDelivery: (v) => {
      //   // if (v) {
      //   //   history.push('/dashboard/notadeentrega/notaventa')
      //   // } else {
      //   //   history.push('/dashboard/modulo_ventas/ventas')
      //   // }
      //   if (status === 'DELIVERY_NOTE') {
      //     setStatus('REFUND')
      //   } if (status === 'REFUND') {
      //     setStatus('DELIVERY_NOTE')
      //   }
      // }
      // })
    )
    return () => {
      setHeaderActions(null)
    }
  }, [
    setHeaderActions,
    selectedClient,
    selectedMethods,
    selectedItems,
    isFreeForm,
    status,
  ])

  const getItemsFromValue = async (): Promise<void> => {
    if (itemToSearch !== '') {
      let response = await axios.get<{ existences: IExistencesResponse[] }>(
        `${server}/inventory/existence/search/custom/1?searchCustom=${itemToSearch}`
      )
      if (response.data.existences.length === 0) {
        addAlert({
          message: 'No hay productos',
          status: 'error',
        })
      } else {
        setItemsSearched(response.data.existences)
        setShowModalItems(true)
      }
    } else {
      setShowModalItems(false)
    }
  }

  const onDeleteItemsSelected = async (
    item: IItem & { amount: string },
    idx: number
  ): Promise<void> => {
    console.log('ENTRA', item)
    console.log('idx', idx)
    if (status === 'PENDING') {
      console.log('primer if...')
      try {
        await axios.delete(`${server}/business/sale/pending/${selldId}`, {
          data: { ids: [item.id] },
        })
        //@ts-ignore
        setSelectedItems((prevState) => [
          ...(prevState?.filter((_, i) => i !== idx) ?? []),
        ])
      } catch (err) {
      } finally {
      }
    } else if (
      status === 'PENDING_DELIVERY' ||
      status === 'DELIVERY_NOTE_TO_SALE'
    ) {
      console.log('ENTRA', item)
      console.log('idx', idx)
      console.log('segundo if...')
      try {
        await axios.delete(
          `${server}/business/delivery-note/pending/${selldId}`,
          { data: { ids: [item.id] } }
        )
        //@ts-ignore
        setSelectedItems((prevState) => [
          ...(prevState?.filter((_, i) => i !== idx) ?? []),
        ])
      } catch (err) {
      } finally {
      }
    } else {
      console.log('tercer if')
      //@ts-ignore
      setSelectedItems((prevState) => [
        ...(prevState?.filter((_, i) => i !== idx) ?? []),
      ])
    }
  }

  const onSubmit = async (values: any): Promise<void> => {
    const _values: { client: Omit<IClient, 'id'> } = values
    const fd = new FormData()

    if (values.clientFile) {
      fd.append('media', values.clientFile)
      fd.append('fileType', 'pdf')
      try {
        addAlert({
          message: 'Creando cliente y subiendo imagen',
          status: 'loading',
        })
        await dispatch(createClient(_values, true, fd))
        await onSearchClient(values?.document?.document, true)
        addAlert({
          message: 'Imagen y cliente creados satisfactoriamente',
          status: 'success',
        })
      } catch (err) {
        addAlert({
          message: 'Error al subir imagen o crear cliente',
          status: 'error',
        })
      } finally {
        // setAlreadySelled(true)
        setShowAddClient(false)
      }
      return
    }

    /* usar try catch */
    try {
      addAlert({
        message: 'Creando cliente...',
        status: 'loading',
      })
      await dispatch(createClient(_values))
      await onSearchClient(values?.document?.document, true)
      addAlert({
        message: 'Cliente creado con éxito',
        status: 'success',
      })
    } catch (err) {
      addAlert({
        message: 'Error al crear cliente',
        status: 'error',
      })
    } finally {
      // setAlreadySelled(true)
      setShowAddClient(false)
    }
  }

  const onCreateSuscription = async (): Promise<void> => {
    try {
      addAlert({
        message: 'Creando suscripción...',
        status: 'loading',
      })
    } catch (err) {
      addAlert({
        message: 'Error al crear suscripción',
        status: 'error',
      })
    }
  }

  const onCreatePendingSell = async (): Promise<void> => {
    if (status === 'DELIVERY_NOTE' || status === 'PENDING_DELIVERY') {
      const objBody = {
        deliveryNote: {
          id: status === 'PENDING_DELIVERY' ? selldId : '',
          client: {
            id: selectedClient?.id,
          },
          //Details -> MOBILEPAYMENT / CASH / CARD / WALLET / WIRE TRANSFER
          // payments: [{
          //   idAccount: "1",
          //   amount: 10000,
          //   details: "CARD",
          //   transactionType: "INCOME",
          //   receipt: "132465789"
          // }],
          payments: selectedMethods.map((method) => ({
            idAccount: method.id,
            amount: +method.amount,
            details: formatValueToSave(method)?.accountType,
            transactionType: 'INCOME',
            receipt: method.ref,
          })),
          unload: {
            destination: {
              id: '1',
              locationType: 'warehouse',
            },
            // items: selectedItems?.map((item) => ({
            //   idItem: item.id,
            //   amount: item.amount,
            // })),
            items: selectedItems?.reduce((a, b) => {
              a = [...a, { idItem: b.id, amount: b.amount }]
              if (b.type === 'COMPOUND' && b.compositionCompound) {
                a = [
                  ...a,
                  ...b.compositionCompound.map((v) => ({
                    idItem: v.item.id,
                    amount: b.amount,
                  })),
                ]
              }
              return a
            }, [] as any),
          },
          // invoice: {
          //   taxPrice: sumOfValues('iva').toFixed(2),
          //   tax: tax+"",
          //   taxBase: sumOfValues('sub_total').toFixed(2),
          //   subTotal: +sumOfValues('exempt').toFixed(2) + +sumOfValues('sub_total').toFixed(2) ,
          //   exempt: +sumOfValues('exempt').toFixed(2),
          //   total: +sumOfValues('sub_total').toFixed(2) + +sumOfValues('iva').toFixed(2) + +sumOfValues('exempt').toFixed(2),
          //   invoiceDetail: {
          //     invoiceNumber: '',
          //     items: selectedItems,
          //   },
          // },
          deliveryNoteDetail: selectedItems,
          cashier: 'Gustavo Parra',
          seller: 'Gustavo Parra',
          totalPrice: sumOfValues('total'),
          paidOut: isPayed,
          type: dispatchStatus,
        },
      }

      addAlert({
        message: 'Creando nota de entrega pendiente',
        status: 'loading',
      })
      try {
        await axios.post(`${server}/business/delivery-note/pending`, objBody)
        addAlert({
          message: 'Nota de entrega pendiente realizada con exito!',
          status: 'success',
        })
        setAlreadySelled(true)
      } catch (err) {
        addAlert({
          message: 'Error al crear nota de entrega pendiente',
          status: 'error',
        })
      } finally {
      }

      return
    }

    const objBody = {
      sale: {
        id: status === 'PENDING' ? selldId : '',
        client: {
          id: selectedClient?.id,
        },
        payments: selectedMethods.map((method) => ({
          idAccount: method.id,
          amount: +method.amount,
          details: formatValueToSave(method)?.accountType,
          transactionType: 'INCOME',
          receipt: method.ref || '',
          paymentStatus: method.paymentStatus,
        })),
        unload: {
          destination: {
            id: '1',
            locationType: 'warehouse',
          },
          items: selectedItems?.map((item) => ({
            idItem: item.id,
            amount: item.amount,
          })),
        },
        cashier: 'Gustavo Parra',
        seller: 'Gustavo Parra',
      },
    }

    try {
      addAlert({ message: 'Creando venta pendiente', status: 'loading' })
      await axios.post(
        `${server}/business/sale/pending/${
          isFreeForm ? 'free-form' : 'invoice'
        }`,
        {
          sale: objBody.sale,
        }
      )
      addAlert({
        message: 'Venta pendiente realizada con exito!',
        status: 'success',
      })
      onContinue()
      history.push('/dashboard/modulo_ventas/historicopendientes')
    } catch (err) {
      addAlert({
        message: 'Error al crear venta pendiente',
        status: 'error',
      })
    }
  }

  const goBack = (): void => {
    setIsFirstRender(true)
    if (!isPaymentMethod && selectedClient) {
      setSelectedItems([])
      setSelectedClient(null)
    }
    if (isPaymentMethod) {
      setIsPaymentMethod(false)
    }
  }

  const cancelSale = async (): Promise<void> => {
    await getRate()
    setSelectedItems([])
    setSelectedMethods([])
    setSelectedClient(null)
    setIsPaymentMethod(false)
    setAlreadySelled(false)
    setIsCashOut(true)
    setIsFirstRender(true)
  }

  const onPressRow = async (item: any): Promise<void> => {
    let idx = selectedItems?.findIndex((v) => v.id === item.id)

    if (status === 'PENDING' || status === 'PENDING_DELIVERY') {
      await axios.patch(
        `${server}/business/${
          status === 'PENDING' ? 'sale' : 'delivery-note'
        }/pending/${selldId}`,
        {
          unload: {
            destination: {
              id: 1,
              locationType: 'warehouse',
            },
            items: [
              {
                idItem: item.item.id,
                amount: '1',
              },
            ],
          },
        }
      )
      if (idx === -1) {
        //@ts-ignore
        setSelectedItems((prevState) => [...prevState, { amount: 1, ...item }])
      } else {
        let copyItems = [...selectedItems]
        copyItems[idx === undefined ? 0 : idx].amount =
          +copyItems[idx === undefined ? 0 : idx].amount + 1
        setSelectedItems(copyItems)
      }
      setSearchItems([])
    } else {
      if (idx === -1) {
        console.log('llega aca 1...')
        const { unit, quantity, inCatalog, description, ...rest } = item
        //@ts-ignore
        setSelectedItems((prevState) => [
          ...prevState,
          { amount: '1', ...item },
        ])
      } else {
        console.log('llega aca 2...')
        let copyItems = [...selectedItems]
        copyItems[idx === undefined ? 0 : idx].amount =
          +copyItems[idx === undefined ? 0 : idx].amount + 1
        setSelectedItems(copyItems)
      }
      setSearchItems([])
    }
  }

  useEffect(() => {
    if (showAddClient) {
      setShowAddClient(false)
      setSelectedClient(clients[clients.length - 1])
    }
  }, [clients])

  useEffect(() => {
    getItemsFromValue()
  }, [itemToSearch])

  useEffect(() => {
    // setAccounts((prevState) => [...prevState.filter((v) => v.accountVisible)])
  }, [])

  useEffect(() => {
    dispatch(fectchAccounts())
  }, [])

  // useEffect(() => {
  //   console.log("folter..", accountsFilter)
  // }, [accountsFilter])

  useEffect(() => {
    if (selectedMethod) {
      if (selectedMethod.accountType === accountTypeEnum.CREDIT) {
        setIsCashOut(false)
      } else {
        setShowMethod((prevState) => !prevState)
      }
    }
  }, [selectedMethod])

  // const onDeletePayment = (idx: number) => {
  //   setSelectedMethods((prevState) => [
  //     ...prevState.filter((prev, index) => index !== idx),
  //   ])
  // }
  const getCurrentDate = () => {
    let days = {
      Mon: 'Lunes',
      Tue: 'Martes',
      Wed: 'Miércoles',
      Thu: 'Jueves',
      Fri: 'Viernes',
      Sat: 'Sábado',
      Sun: 'Domingo',
    }

    let months = {
      Jan: 'Enero',
      Feb: 'Febrero',
      Mar: 'Marzo',
      Apr: 'Abril',
      May: 'Mayo',
      Jun: 'Junio',
      Jul: 'Julio',
      Aug: 'Agosto',
      Sep: 'Septiembre',
      Oct: 'Octubre',
      Nov: 'Noviembre',
      Dec: 'Diciembre',
    }

    const [day, month, year] = saleDate.split('/')

    let currentDate = (new Date(+year, +month - 1, +day) + '').split(' ')
    console.log('CURRENT DATE', currentDate)
    return (
      <>{`${days[currentDate[0]]}, ${currentDate[2]} de ${
        months[currentDate[1]]
      } del ${currentDate[3]}`}</>
    )
  }

  useEffect(() => {
    console.log('SALE DATE', saleDate)
  }, [saleDate])

  const renderInputOptional = () => {
    // if (isPaymentMethod) {
    //   return (
    //     <div className="flex flex-col justify-between">
    //       {isCashOut && (
    //         <>
    //           <div className="flex justify-between items-center">
    //             <div className="flex items-center">
    //               {!alreadySelled && (
    //                 <Button
    //                   classes="border-none"
    //                   onClick={() => goBack && goBack()}
    //                   type="arrow"
    //                   warehouseType="WAREHOUSE"
    //                 >
    //                   <FaArrowLeft size={30} />
    //                 </Button>
    //               )}
    //               <h1 className="text-sm">MÉTODOS DE PAGO</h1>
    //             </div>

    //             {( userRole === 'admin' || userRole === 'general_manager' || userRole === 'master')  && (
    //              <div>
    //               <Datepicker onChangeDate={async (value) => {
    //                 let valueDb = dateToDB(value)
    //                 // console.log("FECHA", dateToDB(value))
    //                 await getRate(valueDb, false)
    //                 const [day, month, year] = value.split("/")
    //                 let valueDate = DateTime.fromISO(valueDb)
    //                 let todayIso = DateTime.fromISO(today.toFormat("yyyy-MM-dd"))
    //                 console.log("vlaue date", valueDate)
    //                 console.log("today iso", todayIso)
    //                 console.log("")
    //                 if (valueDate > todayIso) {
    //                   setSaleDate(today.toFormat("d/M/yyyy"))
    //                   addAlert({
    //                     message: 'La fecha de venta no puede ser mayor a la fecha actual',
    //                     status: 'error',
    //                   })
    //                   setIsDisableForDay(true)
    //                   return
    //                 }
    //                 setIsDisableForDay(false)
    //                 setSaleDate(`${+day < 10 ? +day : day}/${+month < 10 ? +month : month}/${year}`)
    //               }} label="Fecha venta" defaultValue={saleDate} />
    //             </div>
    //              ) }

    //             {/* {selectedClient && +selectedClient.credit > 0 && (
    //           <div
    //             className="flex h-full items-center text-warning-light cursor-pointer"
    //             onClick={() =>
    //               setSelectedMethod({
    //                 name: 'Crédito',
    //                 icon: null,
    //                 accountType: accountTypeEnum.CREDIT,
    //               })
    //             }
    //           >
    //             Pagar con crédito
    //           </div>
    //         )} */}

    //             {/* {status !== 'DELIVERY_NOTE' && (
    //           <h1 className="text-sm text-primary">
    //             {isFreeForm ? 'Forma libre' : 'Factura'}
    //           </h1>
    //         )} */}
    //           </div>

    //           <div className="grid grid-cols-2 gap-3 h-3/6">
    //             {[
    //               {
    //                 name: 'EFECTIVO',
    //                 icon: AiOutlineWallet,
    //                 accountType: accountTypeEnum.CASH,
    //               },
    //               {
    //                 name: 'TARJETA',
    //                 icon: BsCreditCard,
    //                 accountType: accountTypeEnum.CARD,
    //               },
    //               {
    //                 name: 'TRANSFERENCIA/PAGO MÓVIL',
    //                 icon: BiTransfer,
    //                 accountType: accountTypeEnum.BANKACCOUNT,
    //               },
    //               {
    //                 name: 'OTROS PAGOS',
    //                 icon: FaBitcoin,
    //                 accountType: accountTypeEnum.WALLET,
    //               },
    //               {
    //                 name: 'VENTA A CRÉDITO',
    //                 icon: FaCreditCard,
    //                 accountType: accountTypeEnum.CREDIT,
    //               },
    //               {
    //                 name: 'IGTF',
    //                 icon: FaPercent,
    //                 accountType: accountTypeEnum.IGTF,
    //               },
    //             ].map((paymentMethod) => (
    //               <div
    //                 className={`bg-light-200 dark:bg-gray-800 rounded-lg flex justify-center ${!alreadySelled && 'cursor-pointer'
    //                   }`}
    //                 onClick={() =>
    //                   !alreadySelled && setSelectedMethod(paymentMethod)
    //                 }
    //               >
    //                 <div className="flex h-full items-center">
    //                   <div className="mr-2 h-8 w-8 dark:bg-black bg-light-300 rounded-3xl flex justify-center items-center">
    //                     <paymentMethod.icon color="#006AEA" />
    //                   </div>
    //                   <div
    //                     className={`${windowSize.innerWidth < 1200 && 'truncate w-32'
    //                       }`}
    //                   >
    //                     {paymentMethod.name}
    //                   </div>
    //                 </div>
    //               </div>
    //             ))}
    //           </div>

    //           <div
    //             className="overflow-y-auto"
    //             style={{ maxHeight: '20%', marginTop: '3%' }}
    //           >
    //             {selectedMethods.map((method, index) => (
    //               <div
    //                 className="bg-gray-100 dark:bg-gray-800 rounded-lg mt-4 p-2 flex justify-between items-center"
    //                 key={index}
    //               >
    //                 <div>
    //                   {!alreadySelled && (
    //                     <Button classes="border-none">
    //                       {/* <FiTrash2 size={20} color="red" onClick={() => onDeletePayment(index) } /> */}
    //                     </Button>
    //                   )}
    //                 </div>

    //                 <div className="flex">
    //                   {/* {console.log("vuelto",)} */}
    //                   {method.type} : {getDenomination(method?.currency?.id)} {formatPipe(toFixed(+method.amount, 2))}
    //                 </div>
    //               </div>
    //             ))}
    //           </div>

    //           <div style={{ marginTop: '10%' }}>
    //             <div className="flex w-full justify-between">
    //               <h1 className="text-sm">TOTAL INGRESADO</h1>
    //               <h1 className="text-sm text-green-600">
    //                 Bs{' '}
    //                 {formatPipe(toFixed(selectedMethods
    //                   .reduce(
    //                     (a, b) => {
    //                       console.log("VER TOTAL", a + +(b.amount * +b.rate))
    //                       console.log("VER TOTAL 01", b.amount)
    //                       console.log("VER TOTAL 02", +b.rate)
    //                       return a + +(+b.amount * +b.rate)
    //                     }, 0), 2)
    //                   // selectedMethods
    //                   //   .reduce(
    //                   //     (a, b) => a + +(+b.amount * +b.rate).toFixed(2),
    //                   //     0
    //                   //   )
    //                   //   .toFixed(2)
    //                 )}
    //               </h1>
    //             </div>

    //             <div className="flex w-full justify-between">
    //               <h1 className="text-sm">DEUDA</h1>
    //               <h1 className="text-sm text-red-600">
    //                 Bs{' '}
    //                 {status === 'DELIVERY_NOTE' || status === 'PENDING_DELIVERY'
    //                   ? formatPipe(toFixed(+toFixed(sumOfValues('sub_total'), 2) +
    //                     +toFixed(sumOfValues('exempt'), 2) -
    //                     +toFixed(+selectedMethods.reduce((a, b) => a + +b.amount, 0), 2), 2)
    //                     // (
    //                     //   sumOfValues('sub_total') +
    //                     //   sumOfValues('exempt') -
    //                     //   +selectedMethods.reduce((a, b) => a + +b.amount, 0)
    //                     // ).toFixed(2)
    //                   )
    //                   : formatPipe(debt, false, 2, -999999999)}
    //               </h1>
    //             </div>

    //             <div className="flex w-full justify-between">
    //               <h1 className="text-sm">VUELTO</h1>
    //               <h1 className="text-sm text-primary">
    //                 Bs{' '}
    //                 {formatPipe(onGetChange())}
    //               </h1>
    //             </div>

    //           </div>
    //         </>
    //       )}

    //       {!isCashOut && (
    //         <div>
    //           <div className="flex items-center mb-3">
    //             <Button
    //               classes="border-none"
    //               onClick={() => {
    //                 setIsCashOut(true)
    //                 setCredit(null)
    //               }}
    //               type="arrow"
    //               warehouseType="WAREHOUSE"
    //             >
    //               <FaArrowLeft size={30} />
    //             </Button>
    //             <h1 className="text-sm">Ir a pagos de contado</h1>
    //           </div>
    //           <CreditSaleForm onSubmit={setCredit} />
    //         </div>
    //       )}

    //       {/* <Button type="primary" onClick={() => onCreatePendingSell()}>
    //             Pendiente
    //           </Button> */}

    //       {/* <div className="h-3/6 flex flex-col justify-between mt-3">
    //       {['Efectivo', 'Tarjeta', 'Transferencia', 'Tarjeta de regalo'].map(paymentMethod => (
    //         <div className="dark:bg-gray-800 rounded-lg h-1/5">
    //           {paymentMethod}
    //         </div>
    //       ))}
    //     </div> */}
    //     </div>
    //   )
    // }
    if (selectedClient) {
      return (
        <div>
          <div className="flex justify-between w-full mb-5">
            <Button
              classes="border-none"
              onClick={() => goBack && goBack()}
              type="arrow"
              warehouseType="WAREHOUSE"
            >
              <FaArrowLeft size={30} />
            </Button>

            <div className="flex justify-between w-7/12">
              <div className="w-9/12">
                <input
                  type="text"
                  className="dark:bg-gray-800 dark:text-white mt-1 mb-2 h-7"
                  name="code"
                  placeholder="INGRESE EL CÓDIGO O NOMBRE DEL PRODUCTO"
                  autoComplete="off"
                  ref={refCode}
                  onKeyDown={(e) => e.key === 'Enter' && onSearchItem()}
                />
              </div>
              {/* <div className="w-2/12">
            <input
              type="text"
              className="dark:bg-gray-800 dark:text-white mt-1 mb-2"
              name="quantity"
              placeholder="Ingrese cantidad"
              autoComplete="off"
              ref={refQuantity}
            />
           </div> */}
              <div>
                <Button type="primary" onClick={() => onSearchItem()}>
                  Buscar
                </Button>
              </div>
            </div>
          </div>
          {/* Tabla de productos en venta. */}
          <div style={{ height: '350px', width: '100%' }}>
            <Table
              columns={columnsSearchInSell}
              evaluateNegativeRow={true}
              data={searchItems}
              showPagination={false}
              onPressButton={async (item: IExistenceInSale) => {
                onPressRow(item)
                // if (item.item.price.length === 0) {
                //   addAlert({
                //     message: 'Este producto no tiene precio',
                //     status: 'error',
                //   })
                // } else {
                //   onPressRow(item)
                // }
              }}
            />
          </div>
        </div>
      )
    }
    return (
      <div>
        {status === 'PENDING' && (
          <div>
            <div className="flex justify-between w-full mb-5">
              <Button
                classes="border-none"
                onClick={() => onGoBack && onGoBack()}
                type="arrow"
                warehouseType="WAREHOUSE"
              >
                <FaArrowLeft size={30} />
              </Button>

              <div className="flex justify-between w-8/12">
                <div className="w-7/12">
                  {/* <input
                    type="text"
                    className="dark:bg-gray-800 dark:text-white mt-1 h-7"
                    name="cedula"
                    placeholder="Ingrese cédula del cliente"
                    autoComplete="off"
                    ref={refDocument}
                    onChange={(e) => {
                      console.log('e valor', e)
                      if (/^[vjepgc]$/gi.test(e.target.value)) {
                        refDocument.current &&
                          (refDocument.current.value = `${e.target.value.toUpperCase()}-`)
                      }
                    }}
                    onKeyDown={(e) => {
                      console.log('e', e)
                      if (
                        e.key === 'Backspace' &&
                        /^[vjepgc]-$/gi.test(
                          (refDocument.current && refDocument.current.value) ||
                            ''
                        )
                      ) {
                        refDocument.current && (refDocument.current.value = '')
                      }
                    }}
                  />
                  {<p className="text-danger mt-3">{error || ''}</p>} */}
                  <AdvancedSearch
                    onEnter={(values) => {
                      console.log('valor...', values)
                      refInputAdvanced.current = null
                    }}
                    ref={refInputAdvanced}
                  />
                </div>
                <div>
                  <Button type="primary" onClick={() => onSearchClient()}>
                    Buscar
                  </Button>
                </div>

                <div>
                  <Button type="primary" onClick={() => setShowAddClient(true)}>
                    Añadir
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}

        {status != 'PENDING' && (
          <div className="flex justify-between w-full mb-5">
            <div className="w-7/12">
              {/* <input
                type="text"
                className="dark:bg-gray-800 dark:text-white mt-1 h-7"
                name="cedula"
                placeholder="Ingrese cédula del cliente"
                autoComplete="off"
                ref={refDocument}
                onChange={(e) => {
                  onSearchClient()
                  if (/^[vjepgc]$/gi.test(e.target.value)) {
                    console.log('llegando...', e.target.value)
                    refDocument.current &&
                      (refDocument.current.value = `${e.target.value.toUpperCase()}-`)
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    onSearchClient()
                  }
                  if (
                    e.key === 'Backspace' &&
                    /^[vjepgc]-$/gi.test(
                      (refDocument.current && refDocument.current.value) || ''
                    )
                  ) {
                    refDocument.current && (refDocument.current.value = '')
                  }
                }}
              />
              {<p className="text-danger mt-3">{error || ''}</p>} */}
              <AdvancedSearch
                placeholder="INGRESE NRO. DOCUMENTO CLIENTE"
                onEnter={(values) => {
                  console.log('valor...', values)
                  onSearchClient(values)
                  if (refInputAdvanced && refInputAdvanced.current) {
                    console.log('llega..')
                    refInputAdvanced.current.value = ''
                  }
                }}
                ref={refInputAdvanced}
              />
            </div>
            <div>
              <Button
                type="primary"
                classes="rounded"
                onClick={() => onSearchClient()}
              >
                Buscar
              </Button>
            </div>

            <div>
              <Button
                classes="rounded"
                type="primary"
                onClick={() => setShowAddClient(true)}
              >
                Añadir Cliente
              </Button>
            </div>
          </div>
        )}

        <Table
          applyBackgroundHover={true}
          columns={columnsSearchClients}
          data={searchClient}
          showPagination={false}
          onPressButton={(client) => {
            setSearchClient([])
            setSelectedClient(client)
          }}
        />
      </div>
    )
  }

  const onUpdateItem = (idx: number): void => {
    let items = [...selectedItems]
    items[idx].enableEdit = true
    setSelectedItems(items)
  }

  const onSaveUpdateItem = async (
    item: IItem & { amount: string; enableEdit: boolean; id_item_sale: string },
    idx: number
  ): Promise<void> => {
    console.log('ITEM', item)
    await axios.patch(
      `${server}/business/${
        status === 'PENDING' ? 'sale' : 'delivery-note'
      }/pending/amount/${item.id_item_sale}`,
      { amount: item.amount }
    )
    let items = [...selectedItems]
    items[idx].enableEdit = false
    setSelectedItems(items)
  }

  // const getMobileAccounts = () => {
  //   return accountsFilter.reduce((a, b) => {
  //     if (b.mobilePaymentPhone !== '') {
  //       a.push(b)
  //     }
  //     return a
  //   }, [] as IMoneyAccount[] )
  // }

  // const onGetAccountsPhoneFormatter = (): options[] => {
  //   return accountsFilter.reduce((a, b) => {
  //     if (b.mobilePaymentPhone !== '') {
  //       return [
  //         ...a,
  //         {
  //           text: b.mobilePaymentPhone,
  //           value: b.mobilePaymentPhone,
  //         } as options,
  //       ]
  //     }
  //     return a as options[]
  //   }, [] as options[])
  // }

  const onSelectMethod = async (
    method: any,
    type: accountTypeEnum
  ): Promise<void> => {
    console.log('method', method)
    setShowMethod(false)

    let obj = {
      [accountTypeEnum.BANKACCOUNT]: 'Cuenta Bancaria',
      [accountTypeEnum.CARD]: 'Punto de venta',
      [accountTypeEnum.CASH]: 'Efectivo',
      [accountTypeEnum.WALLET]: 'Billetera Virtual',
      [accountTypeEnum.mobilePayment]: 'Pago Móvil',
      [accountTypeEnum.nationalTransfer]: 'Cuenta Bancaria',
      [accountTypeEnum.CREDIT]: 'Crédito',
    }

    console.log('filter..', accounts)

    const today = DateTime.local().setLocale('es')

    let date = today.toISODate()

    if (type === accountTypeEnum.CARD) {
      let response = await axios.get(`${server}/cashier`)
      let idAccount = response?.data?.cashiers[0]?.idPosAccount
      if (!idAccount) {
        addAlert({
          message: 'No hay ninguna cuenta asociada a este cajero',
          status: 'error',
        })
        return
      }
      let newPayment = {
        amount: method.amount,
        reference: method.reference,
        currency: {
          id: '2',
        },
        /** Aqui tengo que colocar la cuenta de debito por defecto */
        account: {
          id: idAccount || '1',
        },
        date,
        type: obj[type],
        rate: '1',
      }
      setSelectedMethods((prevState) => [...prevState, newPayment])

      return
    }

    let account = accounts.find(
      (account) => account.id === method.type
    ) as IMoneyAccount

    console.log('account', account)

    let newPayment = {
      amount: method.amount,
      reference: method.reference,
      currency: {
        id: account.idCurrency,
      },
      account: {
        id: method.type,
      },
      date,
      type: obj[type],
      rate: '1',
    }

    let rate = onGetRate(account.idCurrency)
    console.log('rate...', rate)
    // let rate = globalRate.find(rate => rate.id === account.idCurrency)

    newPayment.rate = rate || newPayment.rate

    // newPayment.amount = +newPayment.rate * +newPayment?.amount || newPayment?.amount

    // if (account.idCurrency !== '2') {
    //   axios.get(`${server}/finances/rate?date=${date}&`)
    // }

    console.group('new payment', newPayment)

    setSelectedMethods((prevState) => [...prevState, newPayment])

    // if (account && method.ref) {
    //   console.log('IF', method)
    //   console.log('tyoe', type)
    //   setSelectedMethods((prevState) => [
    //     ...prevState,
    //     {
    //       ...account,
    //       id: method.type,
    //       amount: method.amount,
    //       type: obj[type],
    //       ref: method.ref,
    //       paymentStatus: TypeStatus.UNDONE,
    //       bills,
    //     },
    //   ])
    // } else {
    //   setSelectedMethods((prevState) => [
    //     ...prevState,
    //     {
    //       ...account,
    //       id: method.type,
    //       amount: method.amount,
    //       type: obj[type],
    //       paymentStatus: TypeStatus.UNDONE,
    //       bills,
    //     },
    //   ])
    // }
  }

  const formatRows = () => {
    let array = []
    if (selectedItems) {
      for (let i = 0; i < selectedItems?.length; i++) {
        let arraySub = [
          selectedItems[i].barcode || selectedItems[i].sku,
          selectedItems[i].name,
          selectedItems[i].amount,
          // selectedItems[i].exempt
          //   ? +selectedItems[i].price[0].amount
          //   : (+selectedItems[i].price[0].amount / Number(`1.${tax}`)).toFixed(
          //       2
          //     ),
          // selectedItems[i].exempt
          //   ? +selectedItems[i].price[0].amount * +selectedItems[i].amount
          //   : (
          //       +(
          //         +selectedItems[i].price[0].amount / Number(`1.${tax}`)
          //       ).toFixed(2) * +selectedItems[i].amount
          //     ).toFixed(2),
        ]
        //@ts-ignore
        array.push(arraySub)
      }
      return array
    }
  }

  const onSubmitCounterFoil = async (values): Promise<void> => {
    const objBody = {
      sale: {
        client: {
          id: selectedClient?.id,
        },
        payments: selectedMethods.map((method) => ({
          idAccount: method.id || '',
          amount: +method.amount,
          details: formatValueToSave(method)?.accountType,
          transactionType: method.type === 'Crédito' ? 'EXPENSES' : 'INCOME',
          receipt: method.ref || '',
          bills: method?.bills,
        })),
        unload: {
          destination: {
            id: '1',
            locationType: 'warehouse',
          },
          // items: selectedItems?.map((item) => ({
          //   idItem: item.id,
          //   amount: item.amount,
          // })),
          items: selectedItems?.reduce((a, b) => {
            a = [...a, { idItem: b.id, amount: b.amount }]
            if (b.type === 'COMPOUND' && b.compositionCompound) {
              a = [
                ...a,
                ...b.compositionCompound.map((v) => ({
                  idItem: v.item.id,
                  amount: b.amount,
                })),
              ]
            }
            return a
          }, [] as any),
        },
        invoice: {
          // taxPrice: sumOfValues('iva').toFixed(2),
          taxPrice: toFixed(sumOfValues('iva'), 2),
          tax: tax + '',
          // taxBase: sumOfValues('sub_total').toFixed(2),
          taxBase: toFixed(sumOfValues('sub_total'), 2),
          // subTotal:
          //   +sumOfValues('exempt').toFixed(2) +
          //   +sumOfValues('sub_total').toFixed(2),
          subTotal: toFixed(
            sumOfValues('exempt') + sumOfValues('sub_total'),
            2
          ),
          // exempt: +sumOfValues('exempt').toFixed(2),
          exempt: toFixed(sumOfValues('exempt'), 2),
          // total:
          //   +sumOfValues('sub_total').toFixed(2) +
          //   +sumOfValues('iva').toFixed(2) +
          //   +sumOfValues('exempt').toFixed(2),
          total: toFixed(
            sumOfValues('sub_total') +
              sumOfValues('iva') +
              sumOfValues('exempt'),
            2
          ),
          invoiceDetail: {
            invoiceNumber: values.invoiceNumber,
            controlNumber: values.controlNumber,
            items: selectedItems,
          },
        },
        deliveryNote: {},
        cashier: 'Gustavo Parra',
        seller: '',
      },
    }

    try {
      await axios.post(`${server}/business/sale/invoice`, {
        sale: objBody.sale,
      })
      setShowModalControlNumber(false)
      addAlert({ message: 'Talonario creado con éxito', status: 'success' })
      setAlreadySelled(true)
    } catch (err) {
      addAlert({
        message: 'Error al crear talonario',
        status: 'error',
      })
    }
  }

  return (
    <div
      className={status === 'DELIVERY_NOTE' ? '' : 'h-full'}
      style={{ height: window.innerHeight - 255 + 'px' }}
    >
      {!showPdf && !showPdfDeliveryNote && (
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-4 h-full">
          {/* Left side */}
          {/* <div>
          {renderInputOptional()}
          <div className="flex justify-center">
            <div className="mt-8 grid grid-cols-2 grid-rows-6 gap-6">
              <div className="dark:bg-gray-400 row-span-3 h-16 w-80 rounded-md">
                <h1 className="text-sm">Efectivo</h1>
              </div>
              <div className="dark:bg-gray-400 row-span-3 w-80 rounded-md">
                <h1 className="text-sm">Tarjeta</h1>
              </div>
              <div className="dark:bg-gray-400 row-span-3 w-80 rounded-md">
                <h1 className="text-sm">Transferencia</h1>
              </div>
              <div className="dark:bg-gray-400 row-span-3 w-80 rounded-md">
                <h1 className="text-sm">Tarjeta de regalo</h1>
              </div>
            </div>
          </div>

          <div className="h-3/6 mt-5">
            <h1>Aqui va mapeo de metodos de pagos.</h1>
          </div>

          <div className="flex justify-center">
            <div className="flex justify-between w-4/12">
              <Button type="primary" onClick={() => onCreateSell()}>
                Continuar
              </Button>
              <Button type="outline">Cancelar</Button>
            </div>
          </div>
        </div> */}

          <div className="h-full">
            <div
              className="bg-light-100 dark:bg-black flex rounded-2xl p-4 grid"
              style={{
                height: '90%',
                overflow: isPaymentMethod ? 'visible' : 'scroll',
              }}
            >
              {renderInputOptional()}
            </div>

            <div
              className="flex justify-center items-end"
              style={{ height: '10%' }}
            >
              {(alreadySelled && status !== 'DELIVERY_NOTE_TO_SALE') ||
              (alreadySelled &&
                status === 'DELIVERY_NOTE_TO_SALE' &&
                finishedDeliveryToSale) ? (
                <div>
                  <Button type="primary" onClick={() => cancelSale()}>
                    {alreadySelled &&
                    (status === 'DELIVERY_NOTE' ||
                      status === 'PENDING_DELIVERY')
                      ? 'Nueva nota de entrega'
                      : 'Nueva venta'}
                  </Button>
                </div>
              ) : (
                <div className="flex justify-between lg:w-6/12 xl:w-4/12">
                  {/* <Button classes="text-white border-none dark:text-white dark:hover:text-white dark:focus:text-white hover:text-white focus:text-white bg-gradient-to-bl from-primary to-primary-dark dark:hover:bg-primary focus:bg-primary dark:focus:bg-primary" onClick={() => {
                // onCreateSell()
                setIsPaymentMethod(true)
                }}
                >
                Continuar
              </Button> */}
                  <Button type="outline" onClick={() => cancelSale()}>
                    Cancelar
                  </Button>

                  <button
                    onClick={() => {
                      const total = +toFixed(getTotalAmount(false), 2)

                      if (total < discountValue) {
                        addAlert({
                          message: 'El descuento no puede ser mayor al total',
                          status: 'error',
                        })
                        return
                      }

                      if (isDisableForDay) {
                        addAlert({
                          message:
                            'La fecha de venta no puede ser mayor a la fecha actual',
                          status: 'error',
                        })
                        return
                      }

                      if (selectedClient && selectedItems?.length! > 0) {
                        setShowCurrencyModal(true)
                        console.log('llegando...')
                      }

                      //   if (isPaymentMethod) {
                      //     if (
                      //       credit?.finalDate &&
                      //       credit.installmentQuantity &&
                      //       credit.installmentRange &&
                      //       credit.installmentRange &&
                      //       credit.startDate
                      //     ) {
                      //       onCreateSell()
                      //       return
                      //     } else if (
                      //       !credit?.finalDate &&
                      //       !credit?.installmentQuantity &&
                      //       !credit?.installmentRange &&
                      //       !credit?.installmentRange &&
                      //       !credit?.startDate
                      //     ) {
                      //       onCreateSell()
                      //       return
                      //     } else {
                      //       addAlert({
                      //         message: 'Por favor, ingresar toda la información',
                      //         status: 'error',
                      //       })
                      //       return
                      //     }
                      //   }
                      // if (status === 'PENDING' && isPaymentMethod) {
                      //   if (isFreeForm) {
                      //     onCreateFreeFormFromPending()
                      //     return
                      //   }
                      //   onEditSale()
                      //   return
                      // }

                      // if (status === 'REFUND' && isPaymentMethod) {
                      //   if (isFreeForm) {
                      //     onCreateSellByFreeForm()
                      //     return
                      //   }
                      //   onCreateSell()
                      //   return
                      // }

                      // if (status === 'DELIVERY_NOTE' && isPaymentMethod) {
                      //   onCreateDeliveryNote()
                      // }

                      // if (
                      //   status === 'DELIVERY_NOTE_TO_SALE' &&
                      //   isPaymentMethod
                      // ) {
                      //   if (isFreeForm) {
                      //     onConvertToFreeFormSale()
                      //     return
                      //   }
                      //   onConvertToInvoiceSale()
                      //   return
                      // }

                      // /* Para cuando se pasa de pendiente a nota de entrega */
                      // if (status === 'PENDING_DELIVERY' && isPaymentMethod) {
                      //   // if (isFreeForm) {
                      //   //   onConvertPendingDeliveryNoteFreeForm()
                      //   //   return
                      //   // }
                      //   onConvertPendingDeliveryNote()
                      //   return
                      // }

                      // if (status === 'COUNTERFOIL' && isPaymentMethod) {
                      //   // console.log("counterfoil...")
                      //   setShowModalControlNumber(true)
                      // }

                      //   setIsPaymentMethod(true)
                    }}
                    disabled={selectedItems?.length === 0}
                    className="text-white border-none dark:text-white dark:hover:text-white dark:focus:text-white hover:text-white focus:text-white bg-gradient-to-bl from-primary to-primary-dark dark:hover:bg-primary focus:bg-primary dark:focus:bg-primary"
                  >
                    <p className="ml-1.5 font-medium tracking-wide flex flex-grow items-center justify-center">
                      Continuar
                    </p>
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* Right side */}
          <div className="h-full">
            <div className="bg-light-100 dark:bg-black rounded-xl h-full p-4 grid grid-rows-6">
              <div className="row-start-1 row-end-1">
                <div className="flex justify-between">
                  <h1 className="text-sm text-primary-700 dark:text-white uppercase">
                    {selectedClient
                      ? `${selectedClient.name}`
                      : 'Nombre del cliente'}
                  </h1>
                  <h1 className="text-sm text-primary-700 dark:text-white uppercase">
                    Documento Legal
                  </h1>
                </div>
                <div className="flex justify-between">
                  <h1 className="text-sm text-primaryGray-400 dark:text-white font-normal uppercase">
                    {getCurrentDate()}
                  </h1>
                  <h1 className="text-sm text-primaryGray-400 dark:text-white font-normal uppercase">
                    {selectedClient
                      ? `${selectedClient.documentType}${selectedClient.document}`
                      : ''}
                  </h1>
                </div>
              </div>

              <div className="row-start-2 row-end-6">
                <div className="max-h-72 overflow-y-auto">
                  {selectedItems?.length === 0 && (
                    <div className="text-sm text-primary-700 dark:text-white text-center">
                      SIN PRODUCTOS
                    </div>
                  )}

                  {selectedItems &&
                    selectedItems?.length > 0 &&
                    selectedItems?.map((item, i) => {
                      return (
                        <div className="mb-3">
                          <div className="grid grid-cols-8 gap-4">
                            <div className="col-span-1 flex justify-center items-center">
                              <div className="flex flex-row justify-center items-center">
                                <IoMdAdd
                                  className="text-primary cursor-pointer"
                                  onClick={() => {
                                    let selected = [...selectedItems]
                                    selected[i].amount =
                                      +selected[i].amount + 1 + ''
                                    setSelectedItems(selected)
                                  }}
                                />
                                {/* <h1 className="text-sm mx-2">{item?.amount}</h1> */}
                                <input
                                  type="number"
                                  value={String(+item.amount)}
                                  onChange={(e) => {
                                    let selected = [...selectedItems]
                                    selected[i].amount =
                                      e.target.value === '0'
                                        ? '1'
                                        : e.target.value
                                    setSelectedItems(selected)
                                  }}
                                  // disabled={
                                  //   ((status === 'PENDING' ||
                                  //     status === 'PENDING_DELIVERY') &&
                                  //     !item?.enableEdit) ||
                                  //   alreadySelled
                                  // }
                                />
                                <BiMinus
                                  className="text-primary cursor-pointer"
                                  onClick={() => {
                                    let selected = [...selectedItems]
                                    if (+selected[i].amount > 1) {
                                      selected[i].amount =
                                        +selected[i].amount - 1 + ''
                                    }
                                    setSelectedItems(selected)
                                  }}
                                />
                              </div>
                            </div>

                            <div
                              className={`col-span-3 ${
                                (status === 'DELIVERY_NOTE' ||
                                  status === 'PENDING_DELIVERY') &&
                                'flex items-center'
                              }`}
                            >
                              <h1 className="text-sm text-primary-700 dark:text-white">
                                {item?.name}
                              </h1>
                              {status !== 'DELIVERY_NOTE' &&
                                status !== 'PENDING_DELIVERY' && (
                                  <div className="flex flex-row">
                                    <h1 className="text-sm text-primaryGray-400 dark:text-white font-medium mr-3">
                                      {item?.ivaType === 'EXEMPT'
                                        ? 'Exento'
                                        : `${(
                                            getIvaNumber(item?.ivaType) + ''
                                          ).replace(/\d\./, '')}%`}
                                    </h1>
                                    <h1 className="text-sm text-primaryGray-400 dark:text-white font-medium">
                                      Código {item.sku}
                                    </h1>
                                  </div>
                                )}
                            </div>

                            <div
                              className={`col-span-3 text-right ${
                                (status === 'DELIVERY_NOTE' ||
                                  status === 'PENDING_DELIVERY') &&
                                'flex items-center'
                              }`}
                            >
                              <h1 className="text-sm text-primary-700 dark:text-white w-full">
                                {/* {item?.ivaType === 'EXEMPT'
                                  ? (
                                      +item?.price * +item.amount
                                    ).toFixed(2)
                                  : (
                                      +(
                                        +item?.price /
                                        getIvaNumber(item?.ivaType)
                                      ) * +item?.amount
                                    ).toFixed(2)  } */}
                                {`Bs. ${formatPipe(
                                  toFixed(
                                    +item.price *
                                      +item?.amount *
                                      +onGetRate(item?.currency?.id),
                                    2
                                  )
                                )}`}
                              </h1>
                              {status !== 'DELIVERY_NOTE' &&
                                status !== 'PENDING_DELIVERY' && (
                                  <h1 className="text-sm text-primaryGray-400 dark:text-white font-medium">
                                    {`Bs. ${
                                      item?.ivaType === 'EXEMPT'
                                        ? '0.00'
                                        : formatPipe(
                                            // (
                                            //   (+item.price *
                                            //     +item.amount *
                                            //     +onGetRate(item.currency.id) *
                                            //     +(
                                            //       getIvaNumber(item?.ivaType) + ''
                                            //     ).replace(/\d\./, '')) /
                                            //   100
                                            // ).toFixed(2)
                                            toFixed(
                                              +toFixed(
                                                +item.price *
                                                  +item.amount *
                                                  +onGetRate(
                                                    item?.currency?.id
                                                  ),
                                                2
                                              ) *
                                                +toFixed(
                                                  +(
                                                    getIvaNumber(
                                                      item?.ivaType
                                                    ) + ''
                                                  ).replace(/\d\./, '') / 100,
                                                  2
                                                ),
                                              2
                                            )
                                          )
                                    }`}
                                  </h1>
                                )}
                            </div>

                            <div className="col-span-1 flex items-center w-full">
                              {(status === 'PENDING' ||
                                status === 'PENDING_DELIVERY' ||
                                status === 'DELIVERY_NOTE_TO_SALE') &&
                                item.enableEdit && (
                                  <HiCheck
                                    size={20}
                                    className="text-primary-700 cursor-pointer w-full"
                                    onClick={() => onSaveUpdateItem(item, i)}
                                  />
                                )}

                              {(status === 'PENDING' ||
                                status === 'PENDING_DELIVERY' ||
                                status === 'DELIVERY_NOTE_TO_SALE') &&
                                !item.enableEdit &&
                                !alreadySelled && (
                                  <HiOutlinePencil
                                    size={20}
                                    className="text-primary-700 cursor-pointer w-full"
                                    onClick={() => onUpdateItem(i)}
                                  />
                                )}
                              {!alreadySelled && !isPaymentMethod && (
                                <RiDeleteBin6Line
                                  className="cursor-pointer w-full text-primary-700"
                                  onClick={() => onDeleteItemsSelected(item, i)}
                                />
                              )}
                            </div>
                          </div>
                        </div>

                        // <div className="mb-3">
                        //   <div className="flex justify-between">
                        //     <h1 className="text-sm">{item?.name}</h1>
                        //     <h1 className="text-sm">
                        //       {+item?.price[item?.price?.length - 1]?.amount *
                        //         +item?.amount}
                        //     </h1>
                        //   </div>
                        //   <div className="flex justify-between">
                        //     <h1 className="text-sm">
                        //       {item?.exempt ? 'Excento' : '16%'}
                        //     </h1>
                        //     <h1 className="text-sm">
                        //       {item?.exempt
                        //         ? '0.00'
                        //         : (
                        //             +item?.price[item?.price?.length - 1]
                        //               ?.amount *
                        //             0.16 *
                        //             +item?.amount
                        //           ).toFixed(2)}
                        //     </h1>
                        //   </div>
                        // </div>
                      )
                    })}
                </div>
              </div>

              <div
                className="row-start-6 row-end-6"
                style={{ marginTop: '-50px' }}
              >
                {/* {status !== 'DELIVERY_NOTE' && status !== 'PENDING_DELIVERY' && (
                  <div className="flex justify-between">
                    <h1 className="text-sm">EXENTO</h1>
                    <h1 className="text-sm">
                      Bs. {sumOfValues('exempt').toFixed(2)}
                    </h1>
                  </div>
                )} */}

                {status !== 'DELIVERY_NOTE' && status !== 'PENDING_DELIVERY' && (
                  <div className="flex justify-between">
                    <h1 className="text-sm">SUB TOTAL</h1>
                    <h1 className="text-sm">
                      Bs.{' '}
                      {formatPipe(
                        toFixed(sumOfValues('sub_total'), 2).replace('.', ',')
                      )}
                    </h1>
                  </div>
                )}

                <div>
                  <div className="flex justify-between">
                    <div className="flex flex-row justify-center items-center">
                      <h1 className="text-sm mr-3">DESCUENTO</h1>
                      <Switch
                        forForm={true}
                        onChange={(value) => {
                          setDiscountValue(0)
                          setDisableDiscount(value)
                          discountRef.current.value = '0'
                        }}
                      />
                    </div>
                    <div className="w-16">
                      <input
                        // min={0}
                        type="text"
                        className="cursor-text transition w-full dark:bg-gray-600 dark:border-gray-600 dark:text-white h-inputDefault"
                        disabled={!disableDiscount}
                        ref={discountRef}
                        // value={discountValue}
                        // onChange={(e) => setDiscountValue(+e.target.value)}
                        // ref={discountInput}
                        // value={discountInput}
                        // onChange={(e) => setDiscountInput(e.target.value)}
                      />
                    </div>
                    {/* <InputNumber label='' disabled={!disableDiscount}  /> */}
                  </div>
                </div>

                <div>
                  <div className="flex justify-between">
                    <h1 className="text-sm">IGTF</h1>
                    <h1 className="text-sm">
                      Bs. {formatPipe(toFixed(igtfAmount, 2).replace('.', ','))}
                    </h1>
                  </div>
                </div>

                {status !== 'DELIVERY_NOTE' && status !== 'PENDING_DELIVERY' && (
                  <div className="flex justify-between">
                    <h1 className="text-sm">IVA</h1>
                    <h1 className="text-sm">
                      Bs.{' '}
                      {formatPipe(
                        toFixed(sumOfValues('iva'), 2).replace('.', ',')
                      )}
                    </h1>
                  </div>
                )}

                <div
                  className={`flex justify-between ${
                    status === 'DELIVERY_NOTE' || status === 'PENDING_DELIVERY'
                      ? 'h-5/6 items-end'
                      : ''
                  }`}
                >
                  <h1 className="text-sm">TOTAL</h1>
                  <h1 className="text-sm">
                    Bs.{' '}
                    {status === 'DELIVERY_NOTE' || status === 'PENDING_DELIVERY'
                      ? formatPipe(
                          toFixed(
                            sumOfValues('sub_total') + sumOfValues('exempt'),
                            2
                          ).replace('.', ',')
                          // (
                          //   sumOfValues('sub_total') + sumOfValues('exempt')
                          // ).toFixed(2)
                        )
                      : +toFixed(getTotalAmount(false), 2) < discountValue
                      ? formatPipe(
                          toFixed(getTotalAmount(false), 2).replace('.', ',')
                        )
                      : formatPipe(
                          toFixed(getTotalAmount(true), 2).replace('.', ',')
                        )}
                  </h1>
                </div>

                {status !== 'DELIVERY_NOTE' && status !== 'PENDING_DELIVERY' && (
                  <div className="flex justify-between">
                    <h1 className="text-sm">TOTAL EN REF.</h1>
                    <h1 className="text-sm">
                      {+toFixed(getTotalAmount(false), 2) < discountValue
                        ? `${formatPipe(
                            toFixed(
                              getTotalAmount(false) / +onGetRate('1'),
                              2
                            ).replace('.', ',')
                          )}`
                        : `$${formatPipe(
                            toFixed(
                              getTotalAmount() / +onGetRate('1'),
                              2
                            ).replace('.', ',')
                          )}`}
                    </h1>
                  </div>
                )}

                {status !== 'DELIVERY_NOTE' && status !== 'PENDING_DELIVERY' && (
                  <div className="flex justify-between">
                    <h1 className="text-sm">TOTAL EN REF (EUR)</h1>
                    <h1 className="text-sm">
                      {+toFixed(getTotalAmount(false), 2) < discountValue
                        ? `${formatPipe(
                            toFixed(
                              getTotalAmount(false) / +onGetRate('3'),
                              2
                            ).replace('.', ',')
                          )}`
                        : `€${formatPipe(
                            toFixed(
                              getTotalAmount() / +onGetRate('3'),
                              2
                            ).replace('.', ',')
                          )}`}
                    </h1>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {showPdf && (
        // <PDFViewer height="100%" width="100%">
        //   <InvoicePdf
        //     selectedClient={selectedClient}
        //     selectedItems={selectedItems}
        //     big={sumOfValues('sub_total').toFixed(2)}
        //     iva={sumOfValues('iva').toFixed(2)}
        //     total={getTotalAmount().toFixed(2)}
        //     exempt={sumOfValues('exempt').toFixed(2)}
        //     correlativeNumber={correlativeNumber}
        //   />
        // </PDFViewer>
        // <PdfView
        //   downloadTitle={`FormaLibre-${'0'.repeat(
        //     6 - correlativeNumber.length
        //   )}${correlativeNumber}`}
        //   column_styles={{ Cant: { width: 200 } }}
        //   type="FREE_FORM"
        //   footer_render={{
        //     sub_total: sumOfValues('sub_total').toFixed(2),
        //     iva: sumOfValues('iva').toFixed(2),
        //     exempt: sumOfValues('exempt').toFixed(2),
        //     total: getTotalAmount().toFixed(2),
        //     clientName: `${selectedClient?.name} ${selectedClient?.surname}`,
        //     clientDocument: `${selectedClient?.documentType}-${selectedClient?.document}`,
        //   }}
        //   title={`Factura - ${'0'.repeat(
        //     6 - correlativeNumber.length
        //   )}${correlativeNumber}`}
        //   columns={[
        //     'Codigo',
        //     'Descripcion',
        //     'Cant',
        //     'Valor uni',
        //     'Valor Total',
        //   ]}
        //   data={formatRows()}
        // />
        // (
        //   +item.price *
        //   +item?.amount *
        //   +onGetRate(item.currency.id)
        // ).toFixed(2)
        <PdfSaleBudget
          client={{
            businessName: selectedClient?.businessName,
            name: selectedClient?.name,
            address: selectedClient?.address,
            phone: selectedClient?.phone1,
            state: selectedClient?.state,
            city: selectedClient?.city,
            rif: `${selectedClient?.documentType}${selectedClient?.document}`,
          }}
          subTotal={formatPipe(
            toFixed(pdfData?.subTotal || 0, 2).replace('.', ',')
          )}
          descuento={formatPipe(toFixed(pdfData?.discount || 0, 2).replace('.', ','))}
          iva={formatPipe(toFixed(pdfData?.iva || 0, 2).replace('.', ','))}
          total={formatPipe(toFixed(pdfData?.total || 0, 2).replace('.', ','))}
          data={pdfData?.items?.map((v: any) => [
            v?.amount,
            v?.description || v?.name,
            formatPipe(
              toFixed(v.priceInTargetCurrency, 2).replace('.', ',')
            ),
            formatPipe(
              toFixed(v.totalInTargetCurrency, 2).replace('.', ',')
            ),
          ])}
          image={userInfo?.image}
          businessSocial={userInfo?.businessSocial}
          businessDocument={`${userInfo?.document?.documentType}-${userInfo?.document?.document}`}
          currency={pdfData?.currencySymbol || 'Bs.'}
        />
        // <PdfSale
        //   invoiceNumber={''}
        //   paidOut={+debt === 0}
        //   client={{
        //     name: selectedClient?.name,
        //     address: selectedClient?.address,
        //     phone: selectedClient?.phone1,
        //     state: selectedClient?.state,
        //     city: selectedClient?.city,
        //     rif: `${selectedClient?.documentType}${selectedClient?.document}`,
        //   }}
        //   data={selectedItems?.map((v) => ({
        //     amount: v.amount,
        //     description: v.name,
        //     individualPrice: +v.price * +onGetRate(v.currency.id),
        //     totalPrice: +v.price * +v.amount * +onGetRate(v.currency.id),
        //   }))}
        // //   date={saleDate}
        //   subTotal={toFixed(sumOfValues('sub_total'), 2)}
        //   descuento={toFixed(discountValue, 2)}
        //   igtf={toFixed(igtfAmount, 2)}
        //   iva={toFixed(sumOfValues('iva'), 2)}
        //   total={toFixed(getTotalAmount(), 2)}
        //   type="BUDGET"
        //   image={userInfo?.image}
        // />
      )}

      {showPdfDeliveryNote && (
        <PdfView
          downloadTitle={`NotaDeEntrega-${'0'.repeat(
            6 - correlativeNumber.length
          )}${correlativeNumber}`}
          column_styles={{ Cant: { width: 200 } }}
          type="DELIVERY_NOTE"
          footer_render={{
            total: sumOfValues('sub_total') + sumOfValues('exempt'),
            clientName: `${selectedClient?.name} ${selectedClient?.surname}`,
            clientDocument: `${selectedClient?.documentType}-${selectedClient?.document}`,
          }}
          title={`Nota de entrega - ${'0'.repeat(
            6 - correlativeNumber.length
          )}${correlativeNumber}`}
          columns={[
            'Codigo',
            'Descripcion',
            'Cant',
            'Valor uni',
            'Valor Total',
          ]}
          data={formatRows()}
        />
      )}

      <Modal
        display={showModalItems}
        // modalClasses="w-3/5 py-4 px-12"
        onAccept={() => null}
        onClose={() => {
          setItemToSearch('')
        }}
      >
        <div>
          <Table
            columns={columnsSearchItems}
            data={itemsSearched}
            showPagination={false}
          />
        </div>
      </Modal>

      <Modal
        display={showAddClient}
        // modalClasses="w-3/6 py-4 px-12 overflow-scroll"
        onAccept={() => null}
        onClose={() => {
          setShowAddClient(false)
        }}
      >
        <ClientForm
          useType={'create'}
          onSubmit={onSubmit}
          onCancel={() => {
            setShowAddClient(false)
          }}
        />
      </Modal>

      {/* <ModalConfirm displayConfirmModal={isFreeForm} title={''} onCancel={() => {
        setIsFreeForm(false)
        checkedSaleCopy && checkedSaleCopy()
        }} onConfirm={() => null}  /> */}

      <Modal
        xlClasses="w-4/12"
        display={showModalControlNumber}
        onClose={() => setShowModalControlNumber(false)}
      >
        <ControlNumberForm
          onClose={() => setShowModalControlNumber(false)}
          onSubmitProp={onSubmitCounterFoil}
        />
      </Modal>

      <Modal
        display={showMethod}
        onClose={() => setShowMethod(false)}
        // modalClasses="w-1/3 py-4 px-12"
      >
        <>
          {/* {selectedMethod?.accountType === accountTypeEnum.CREDIT && (
            <h1>Credit</h1>
          )} */}

          {selectedMethod?.accountType === accountTypeEnum.IGTF && (
            <IgtfForm
              onCancel={() => setShowMethod(false)}
              rate={globalRate}
              onSubmit={setIgtfAmount}
            />
          )}

          {selectedMethod?.accountType === accountTypeEnum.BANKACCOUNT && (
            <div>
              <TransferForm
                rate={globalRate}
                debt={debt}
                onSubmitProp={(v) => onSelectMethod(v, v.type_account)}
                onCancel={() => setShowMethod(false)}
                options={[
                  { text: 'Pago movil', value: 'mobilePayment' },
                  { text: 'Transferencia Nacional', value: 'nationalTransfer' },
                ]}
              />
            </div>
          )}

          {selectedMethod?.accountType === accountTypeEnum.CASH && (
            <div>
              <CashForm
                rate={globalRate}
                debt={
                  status === 'DELIVERY_NOTE' || status === 'PENDING_DELIVERY'
                    ? toFixed(
                        +toFixed(sumOfValues('sub_total'), 2) +
                          +toFixed(sumOfValues('exempt'), 2) -
                          +toFixed(
                            +selectedMethods.reduce((a, b) => a + +b.amount, 0),
                            2
                          ),
                        2
                      )
                    : debt
                }
                // total={
                //   +(
                //     getTotalAmount() -
                //     +selectedMethods
                //       .reduce((a, b) => a + +b.amount, 0)
                //       .toFixed(2)
                //   ).toFixed(2)
                // }

                onCancel={() => setShowMethod(false)}
                onSubmitProp={(v) => onSelectMethod(v, accountTypeEnum.CASH)}
              />
            </div>
          )}

          {selectedMethod?.accountType === accountTypeEnum.CARD && (
            <div>
              <CardForm
                debt={
                  status === 'DELIVERY_NOTE' || status === 'PENDING_DELIVERY'
                    ? toFixed(
                        sumOfValues('sub_total') +
                          sumOfValues('exempt') -
                          +selectedMethods.reduce((a, b) => a + +b.amount, 0)
                      )
                    : debt
                }
                total={
                  +toFixed(
                    getTotalAmount() -
                      +selectedMethods.reduce((a, b) => a + +b.amount, 0),
                    2
                  )
                  // +(
                  //   getTotalAmount() -
                  //   +selectedMethods
                  //     .reduce((a, b) => a + +b.amount, 0)
                  //     .toFixed(2)
                  // ).toFixed(2)
                }
                onCancel={() => setShowMethod(false)}
                onSubmitProp={(v) => onSelectMethod(v, accountTypeEnum.CARD)}
              />
            </div>
          )}

          {selectedMethod?.accountType === accountTypeEnum.WALLET && (
            <div>
              <WalletForm
                debt={
                  status === 'DELIVERY_NOTE' || status === 'PENDING_DELIVERY'
                    ? toFixed(
                        sumOfValues('sub_total') +
                          sumOfValues('exempt') -
                          +selectedMethods.reduce((a, b) => a + +b.amount, 0),
                        2
                      )
                    : // (
                      //     sumOfValues('sub_total') +
                      //     sumOfValues('exempt') -
                      //     +selectedMethods.reduce((a, b) => a + +b.amount, 0)
                      //   ).toFixed(2)
                      toFixed(
                        getTotalAmount() -
                          +selectedMethods.reduce((a, b) => a + +b.amount, 0),
                        2
                      )
                  // (
                  //     getTotalAmount() -
                  //     +selectedMethods.reduce((a, b) => a + +b.amount, 0)
                  //   ).toFixed(2)
                }
                total={
                  +toFixed(
                    getTotalAmount() -
                      +selectedMethods.reduce((a, b) => a + +b.amount, 0),
                    2
                  )
                  // +(
                  //   getTotalAmount() -
                  //   +selectedMethods
                  //     .reduce((a, b) => a + +b.amount, 0)
                  //     .toFixed(2)
                  // ).toFixed(2)
                }
                onCancel={() => setShowMethod(false)}
                onSubmitProp={(v) => onSelectMethod(v, accountTypeEnum.WALLET)}
              />
            </div>
          )}

          {/* {selectedMethod?.accountType === accountTypeEnum.CREDIT && (
            <div>
              <CreditForm
                debt={
                  status === 'DELIVERY_NOTE' || status === 'PENDING_DELIVERY'
                    ? (
                        sumOfValues('sub_total') +
                        sumOfValues('exempt') -
                        +selectedMethods.reduce((a, b) => a + +b.amount, 0)
                      ).toFixed(2)
                    : (
                        getTotalAmount() -
                        +selectedMethods.reduce((a, b) => a + +b.amount, 0)
                      ).toFixed(2)
                }
                total={
                  +(
                    getTotalAmount() -
                    +selectedMethods
                      .reduce((a, b) => a + +b.amount, 0)
                      .toFixed(2)
                  ).toFixed(2)
                }
                credit={selectedClient && +selectedClient.credit}
                onSubmitProp={(v) => onSelectMethod(v, accountTypeEnum.CREDIT)}
                onCancel={() => {
                  setSelectedMethod(null)
                  setShowMethod(false)
                }}
              />
            </div>
          )} */}
        </>
      </Modal>

      <Modal
        display={showAdvancedPayable}
        onClose={() => setShowAdvancedPayable(false)}
      >
        <h2 className="text-base text-primary">
          {`Tu pago supera en Bs.${+debt * -1} el costo de la venta 
          ¿Cómo deseas registrar el excedente del pago?"`}
        </h2>
        <div className="h-px dark:bg-primaryGray-600 bg-primaryGray-700 col-span-12 mt-5"></div>

        <div className="flex flex-row justify-around mt-5">
          <label
            className="cursor-pointer hover:text-primary"
            style={{ flexBasis: '40%' }}
            onClick={async () => {
              let body = returnBody('PAYABLE')
              const today = DateTime.local().setLocale('es')

              try {
                addAlert({
                  message: 'Creando venta...',
                  status: 'loading',
                })
                let response = await axios.post(`${server}/sale`, body)
                if (selectedClient?.email) {
                  let emailBody = {
                    invoiceCode: response?.data?.invoice?.code,
                    nevulaUser: {
                      businessName: userName,
                    },
                    client: {
                      name: selectedClient?.name,
                      document: `${selectedClient?.documentType}-${selectedClient?.document}`,
                      email: selectedClient?.email,
                    },
                    // subTotal: sumOfValues('sub_total').toFixed(2),
                    subTotal: toFixed(sumOfValues('sub_total'), 2),
                    // iva: sumOfValues('iva').toFixed(2),
                    iva: toFixed(sumOfValues('iva'), 2),
                    discount: discountValue + '',
                    // igtf: igtfAmount.toFixed(2),
                    igtf: toFixed(igtfAmount, 2),
                    // total: getTotalAmount().toFixed(2),
                    total: toFixed(getTotalAmount(), 2),
                    date: today.toISODate(),
                    userMessage: 'Gracias por tu compra en Supermarket Luis',
                    logoURL:
                      'https://i.pinimg.com/736x/ec/7c/af/ec7cafae1224c318796d41e728eacb6d.jpg',
                    items: selectedItems?.map((item) => ({
                      quantity: item.amount,
                      description: item.name,
                      unitPrice: item.price,
                      totalPrice: +item?.amount * +item?.price,
                    })),
                  }
                  let responseEmail = await axios.post(
                    `${server}/sale/email`,
                    emailBody
                  )
                }
                setInvoiceNumber(response?.data?.invoice?.code)
                addAlert({
                  message: 'Venta creada satisfactoriamente',
                  status: 'success',
                })
                setShowAdvancedPayable(false)
                setShowPdf(true)
              } catch (err) {
                addAlert({
                  message: 'Error al crear la venta',
                  status: 'error',
                })
              }

              // onFinish()
            }}
          >
            Registrar como deuda por pagar al cliente
          </label>
          <label
            className="cursor-pointer hover:text-primary"
            style={{ flexBasis: '40%' }}
            onClick={async () => {
              let body = returnBody('ADVANCE')
              const today = DateTime.local().setLocale('es')

              try {
                addAlert({
                  message: 'Creando venta...',
                  status: 'loading',
                })
                let response = await axios.post(`${server}/sale`, body)
                if (selectedClient?.email) {
                  let emailBody = {
                    invoiceCode: response?.data?.invoice?.code,
                    nevulaUser: {
                      businessName: userName,
                    },
                    client: {
                      name: selectedClient?.name,
                      document: `${selectedClient?.documentType}-${selectedClient?.document}`,
                      email: selectedClient?.email,
                    },
                    // subTotal: sumOfValues('sub_total').toFixed(2),
                    subTotal: toFixed(sumOfValues('sub_total'), 2),
                    // iva: sumOfValues('iva').toFixed(2),
                    iva: toFixed(sumOfValues('iva'), 2),
                    discount: discountValue + '',
                    // igtf: igtfAmount.toFixed(2),
                    igtf: toFixed(igtfAmount, 2),
                    // total: getTotalAmount().toFixed(2),
                    total: toFixed(getTotalAmount(), 2),
                    date: today.toISODate(),
                    userMessage: 'Gracias por tu compra en Supermarket Luis',
                    logoURL:
                      'https://i.pinimg.com/736x/ec/7c/af/ec7cafae1224c318796d41e728eacb6d.jpg',
                    items: selectedItems?.map((item) => ({
                      quantity: item.amount,
                      description: item.name,
                      unitPrice: item.price,
                      totalPrice: +item?.amount * +item?.price,
                    })),
                  }
                  let responseEmail = await axios.post(
                    `${server}/sale/email`,
                    emailBody
                  )
                }
                setInvoiceNumber(response?.data?.invoice?.code)
                addAlert({
                  message: 'Venta creada satisfactoriamente',
                  status: 'success',
                })
                setShowAdvancedPayable(false)
                setShowPdf(true)
              } catch (err) {
                addAlert({
                  message: 'Error al crear la venta',
                  status: 'error',
                })
              }
              setShowAdvancedPayable(false)
              // onFinish()
            }}
          >
            Registrar como anticipo al cliente
          </label>
        </div>
      </Modal>

      <Modal
        xlClasses="xl:w-2/5"
        display={false}
        onClose={() => setModalRate(null)}
      >
        <div>
          <div className="mb-2 flex items-center">
            <h1>Atención</h1>
          </div>
          <label>
            Se utilizará la tasa Bs/USD de la fecha seleccionada:{' '}
            <strong>
              Bs. {formatPipe(toFixed(+(modalRate || 0), 2).replace('.', ','))}
            </strong>
          </label>
          <div className="flex justify-center mt-5">
            <Button
              // style={returnStyle('ArrowRight')}
              classes="rounded w-5/12"
              type="primary"
              // style={{borderColor: '#D32F2F' }}
              onClick={() => setModalRate(null)}
            >
              Confirmar
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        xlClasses="xl:w-2/5"
        display={showCurrencyModal}
        onClose={handleCancelCurrency}
      >
        <div>
          <div className="mb-4">
            <h1 className="text-lg font-semibold text-primary-700 dark:text-white">
              ¿En qué moneda desea generar el presupuesto?
            </h1>
          </div>

          <div className="flex flex-col gap-3 mt-6">
            <div
              className={`p-4 border-2 rounded-lg cursor-pointer transition-all ${
                selectedPdfCurrency === '2'
                  ? 'border-primary bg-primary-100 dark:bg-primary-900'
                  : 'border-gray-300 hover:border-primary'
              }`}
              onClick={() => setSelectedPdfCurrency('2')}
            >
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-base font-semibold">Bolívares (Bs.)</h3>
                  <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                    El presupuesto se mostrará en bolívares
                  </p>
                </div>
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                  selectedPdfCurrency === '2'
                    ? 'border-primary bg-primary'
                    : 'border-gray-300'
                }`}>
                  {selectedPdfCurrency === '2' && (
                    <div className="w-2 h-2 rounded-full bg-white" />
                  )}
                </div>
              </div>
            </div>

            <div
              className={`p-4 border-2 rounded-lg cursor-pointer transition-all ${
                selectedPdfCurrency === '1'
                  ? 'border-primary bg-primary-100 dark:bg-primary-900'
                  : 'border-gray-300 hover:border-primary'
              }`}
              onClick={() => setSelectedPdfCurrency('1')}
            >
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-base font-semibold">Referencia (REF)</h3>
                  <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                    El presupuesto se mostrará en referencia (USD)
                  </p>
                </div>
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                  selectedPdfCurrency === '1'
                    ? 'border-primary bg-primary'
                    : 'border-gray-300'
                }`}>
                  {selectedPdfCurrency === '1' && (
                    <div className="w-2 h-2 rounded-full bg-white" />
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-end gap-3 mt-6">
            <Button type="outline" onClick={handleCancelCurrency}>
              Cancelar
            </Button>
            <Button type="primary" onClick={handleGeneratePdf}>
              Generar
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  )
}

interface IExistencesResponse {
  date: string
  item: IItem
  location: IWarehouse
  quantity: string
}

interface IMethods {
  name: string
  icon: IconType | null
  accountType: accountTypeEnum
}

interface SellProps {
  setHeaderActions: React.Dispatch<React.SetStateAction<HeaderActions | null>>
  clientProp?: IClient | null
  itemsProp?: any[]
  statusProp?:
    | 'PENDING'
    | 'REFUND'
    | 'DELIVERY_NOTE'
    | 'DELIVERY_NOTE_TO_SALE'
    | 'PENDING_DELIVERY'
    | undefined
  selldId?: string
  payment_methods?: any[] | undefined
  onGoBack?: Function
  type?: string
  alreadySelledProp?: boolean
  dispatchStatusProps?: string
  paidOut?: boolean
  onContinue?: Function
}

interface options {
  value: string
  text: string
}

interface Bill {
  quantity: number
  amountCash: number
}

export interface IGlobalRate {
  id: string
  rate: string
}

interface ICredit {
  installmentRange: string
  installmentQuantity: string
  startDate: string
  finalDate: string
}

export default Budgets
